<template lang='pug'>
    #Account.main-page.detail-page
        v-overlay(v-model='loading' z-index='99' opacity='.6')
            v-progress-circular(indeterminate color='primary')
        div.height_100(v-show='!loading')
            v-breadcrumbs.pa-0.px-3.pb-2(:items='breadcrumbs')
            v-row#page-head.d-flex.align-center.my-0
                v-col(cols='4' lg='6' )
                    .d-flex.align-center.title-height
                        v-hover
                            template(v-slot:default="{ hover }")
                                v-list-item-avatar.ma-0.mr-3(color='aliceBlue')
                                    v-icon.mx-auto(v-if="orgDetail.image === null") {{ orgDetail.name }}
                                    img(v-else :src='orgDetail.image' :alt='orgDetail.image')
                                    v-fade-transition.d-flex.align-center.justify-center
                                        v-overlay.d-flex.align-center.justify-center(v-if="hover" absolute color='black')                                           
                                            v-file-input.no-border(v-show="false" v-model="orgImage" ref="uploader" @change="uploadimage" accept="image/*")                                            
                                            v-icon(@click="changephoto" size='25') mdi-camera
                        h1.my-0.ellipsis(:title='orgDetail.name') {{ orgDetail.name }}
                        followBtn(:follow='isFollow' :page='"Organization"' :target_id='target_id' @emitChangeFollow='onEmitChangeFollow')
                v-col(cols='8' lg='6')
                    v-row.justify-end(no-gutters='no-gutters')
                        v-col.ml-2(cols='auto' v-if='checkWiadvanceShow()')
                            .btn-group                                
                                v-btn(@click='onDelete(orgDetail.id)' width='60' height='30' color='white' depressed tile dark)
                                    span {{$t('GENERAL.DELETE')}}
                        v-col.ml-2(cols='auto' v-if='checkWiadvanceShow()')
                            .btn-group
                                v-btn(@click='onChangeOwn(orgDetail)' width='100%' height='30' color='white' depressed tile dark)
                                    span {{$t('GENERAL.CHANGE_OWNER')}}
                        v-col.ml-2(cols='auto')
                            v-btn(@click='showAddDealDialog' width='100%' height='32' color='orange' depressed dark)
                                v-icon.mr-1(size='14') icon-add
                                span {{$t('GENERAL.ADD_DEAL')}}
                        v-col.ml-2(cols='auto' v-if='!isWiadvance()')
                            v-btn(@click='showAddCaseDialog' width='100%' height='32' color='green' depressed dark)
                                v-icon.mr-1(size='14') icon-add
                                span {{$t('GENERAL.ADD_Case')}}
                        v-col.ml-2(v-if='isWiadvance()' cols='auto')
                            v-btn(@click='goVcfPage' width='100%' height='32' color='blue' depressed dark)
                                span {{$t('COMPANY.VCF')}}
            #page-inner.pa-3.pt-0
                v-card.card-preface.card-shadow.px-0.py-6(flat)
                    v-row
                        v-col.px-2.px-md-4.py-0(cols='6' md='3')
                            v-list-item.d-flex.align-center.px-0
                                v-list-item-icon.mt-3.mb-0.mr-2
                                    v-icon(size='28') mdi-phone
                                v-list-item-content.pa-0
                                    v-card-subtitle.pa-0.t-lightgary {{$t('COMPANY_DETAIL.PHONE')}}
                                    a.f-text-highlight.mb-0.ellipsis(:href='onCall(orgDetail.main_phone)' target='_blank') {{ orgDetail.main_phone }}
                        v-col.px-2.px-md-4.py-0.border-left(cols='6' md='3')
                            v-list-item.d-flex.align-center.px-0
                                v-list-item-icon.mt-3.mb-0.mr-2
                                    v-icon(size='28') mdi-map
                                v-list-item-content.pa-0
                                    v-card-subtitle.pa-0.t-lightgary {{$t('COMPANY_DETAIL.ADDRESS')}}
                                    a.f-text-highlight.mb-0.ellipsis(:href='getGoogleMapSearchURL(orgDetail.billing_address)' target='_blank') {{ orgDetail.country }}{{ orgDetail.city }}{{ orgDetail.billing_address }}
                        v-col.px-2.px-md-4.py-0.border-left(cols='6' md='3')
                            v-list-item.d-flex.align-center.px-0
                                v-list-item-icon.mt-3.mb-0.mr-2
                                    v-icon(size='28') mdi-earth
                                v-list-item-content.pa-0
                                    v-card-subtitle.pa-0.t-lightgary {{$t('COMPANY_DETAIL.WEB')}}
                                    a.f-text-highlight.mb-0.ellipsis(:href='orgDetail.website' target='_blank') {{ orgDetail.website }}
                        v-col.px-2.px-md-4.py-0.border-left(cols='12' md='3')
                            v-list-item.d-flex.align-center.pa-0
                                v-list-item-avatar.ma-0.mr-2(color='aliceBlue')
                                    span.mx-auto(v-if="!isPhoto") {{ changeOwnData.last_name }}
                                    img(v-else :src='changeOwnData.usersetting.photo' :alt='changeOwnData.last_name')
                                v-list-item-content.pa-0.orgDetail
                                    v-card-subtitle.pa-0.t-lightgary {{$t('COMPANY_DETAIL.OWNER')}}
                                    a.t-primary.mb-0.f-text-highlight(:href='onMail(changeOwnData.email)') {{ changeOwnData.last_name }} {{ changeOwnData.first_name }}
                v-row.pinning-card.hidden-sm-only.hidden-xs-only(no-gutters v-for='(item,index) in alertNote' :key='index' :style='setPosition(index)' :class='pinning ? "": "d-none"')
                    v-col(cols='1')
                        v-icon.ml-2(color='white') mdi-firework
                    v-col(:cols='index === 0 ? "7" : "9"').ellipsis
                        strong.ellipsis {{ item.content.replace( /(<([^>]+)>)/ig, '') }}
                    v-col(:cols='index === 0 ? "4" : "2" ').d-flex.justify-end
                        span.ml-3 {{ item.alertTime }} 
                        .mx-3.d-flex( v-if='index === 0')
                            v-btn.process-box-open(v-hide-element='false' v-if='alertNote.length > 1' width='24' height='24' depressed fab outlined @click='folder(index)')
                                v-icon(size='14' v-if='getfolder === false') icon-arrow-top
                                v-icon(size='14' v-else) icon-arrow-btm
                            v-menu(bottom left)
                                template(v-slot:activator='{ on, attrs }')
                                    v-btn.ml-3(v-hide-element='false' color='white' dark v-bind='attrs' v-on='on' icon dense min-height='20' height='20' width='20')
                                        v-icon(size='16')  icon-dot-3
                                v-list.pa-0
                                    v-list-item.px-0.text-center
                                        v-btn(v-hide-element='false' @click='onPinning()' text='text')
                                            span.ml-1 {{$t('GENERAL.CLOSE')}}
                v-row.account-info.mt-5(no-gutters='no-gutters')
                    v-col(cols='12' md='8')
                        v-card.deal-tab-card(flat)
                            v-tabs.main-tabs(v-model='tab' background-color='transparent' show-arrows)
                                v-tabs-slider
                                v-tab(v-for='item in tabs' :key='item.key' :href='`#tab-${item.id}`' @click='getTabName(item.key)')
                                    | {{ item.name }}
                                // - Detail -
                                v-tab-item.pa-3(key='detail' value='tab-1' :transition='false' :reverse-transition='false')
                                    opptyCard.mb-4(:open-oppties='openOppties')
                                    caseCard.mt-7.mb-4(v-if='!isWiadvance()' :open-cases='openCases' :open-amount='openCasesCount')
                                    h3.mt-7.mb-4.d-flex.align-center
                                        .cube-icon.small.bg-primary.mr-2
                                            v-icon(size='20' color='white') mdi-domain
                                        span {{$t('COMPANY_DETAIL.INFO')}}
                                    v-form(v-model='valid' ref='form')
                                        v-row(no-gutters)
                                            v-col.pr-md-4(cols='12' md='6').my-1
                                                p.d-flex.align-center.input-has-label
                                                    label(for='client') {{$t('COMPANY_DETAIL.NAME')}}
                                                    v-text-field#client(v-if='isWiadvance()' v-model='orgDetail.name' solo='solo' readonly )
                                                    v-text-field#client(v-else v-model='orgDetail.name' solo='solo' :readonly='isDetailReadonly' :rules='formRule.nameRules')
                                                        template(v-slot:append)
                                                            v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='confirmEditDetail()') icon-check
                                                            v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='cancelEditDetail()') mdi-window-close  
                                                            v-icon(size='18' v-if='showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                            v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                            v-col.pr-md-4(cols='12' md='6')
                                                div.d-flex.align-center.justify-space-between.input-has-label(:class='isDetailReadonly ? "py-2" : ""')
                                                    .d-inline-flex.align-center.w-100
                                                        label(for='cell') {{$t('COMPANY_DETAIL.PHONE')}}
                                                        v-text-field#cell(v-if='!isDetailReadonly' v-model='orgDetail.main_phone' solo='solo' :rules='formRule.contentLenRule50' :readonly='!checkWiadvanceShow()')
                                                            template(v-slot:append) 
                                                                v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                                v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                                v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                                        .d-flex.justify-space-between.w-100.ellipsis(v-else)
                                                            a.t-primary.ellipsis(:href='onCall(orgDetail.main_phone)') {{ orgDetail.main_phone }} 
                                                            v-icon(size='18' v-if='checkWiadvanceShow() && showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                            v-col.pr-md-4(cols='12' md='6').my-1
                                                p.d-flex.align-center.input-has-label
                                                    label(for='client') {{$t('COMPANY_DETAIL.NAME_EN')}}
                                                    v-text-field#client(v-model='orgDetail.english_department' solo='solo' :readonly='isDetailReadonly || !checkWiadvanceShow()' )
                                                        template(v-slot:append)
                                                            v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                            v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                            v-icon(size='18' v-if='checkWiadvanceShow() && showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                            v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                            v-col.pr-md-4(cols='12' md='6').my-1
                                                p.d-flex.align-center.input-has-label
                                                    label(for='fax') {{$t('COMPANY_DETAIL.FAX')}}
                                                    v-text-field#peoples(v-model='orgDetail.fax' solo='solo' :readonly='isDetailReadonly || !checkWiadvanceShow()' :rules='formRule.contentLenRule20' )
                                                        template(v-slot:append)
                                                            v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                            v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                            v-icon(size='18' v-if='checkWiadvanceShow() && showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                            v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                            v-col.pr-md-4(cols='12' md='6').my-1
                                                p.d-flex.align-center.input-has-label
                                                    label {{'Customer Code'}}
                                                    v-select#peoples.no-border(v-if='isWiadvance()' v-model='orgDetail.customer_code' solo='solo' :readonly='isDetailReadonly' :clearable='!showDetailEditBtn && !loading_orgDeatil' :rules='formRule.selectRuleX' :items="customer_code_List" item-text="name" item-value="key" @change='auto_complete_by_bc_data' :class=' isDetailReadonly ? "remove-arrow" : ""' :menu-props='{closeOnClick:true}')
                                                        template(v-slot:append-outer)
                                                            v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='confirmEditDetail()') icon-check
                                                            v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='cancelEditDetail()') mdi-window-close
                                                            v-icon(size='18' v-if='showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                            v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')                  
                                                    v-text-field#peoples(v-else v-model='orgDetail.customer_code' solo='solo' :readonly='isDetailReadonly' :rules='formRule.contentLenRule100')   
                                                        template(v-slot:append)
                                                            v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='confirmEditDetail()') icon-check
                                                            v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='cancelEditDetail()') mdi-window-close  
                                                            v-icon(size='18' v-if='showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                            v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                            v-col.pr-md-4(cols='12' md='6').my-1
                                                p.d-flex.align-center.input-has-label
                                                    label(for='company_number') {{$t('COMPANY_DETAIL.COMPANY_NUMBER')}}
                                                    v-text-field#peoples(v-if='isWiadvance()' v-model='orgDetail.company_number' solo='solo' readonly :rules='formRule.contentLenRule20')   
                                                        template(v-slot:append)
                                                    v-text-field#peoples(v-else v-model='orgDetail.company_number' solo='solo' :readonly='isDetailReadonly' :rules='formRule.contentLenRule20')   
                                                        template(v-slot:append)
                                                            v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='confirmEditDetail()') icon-check
                                                            v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='cancelEditDetail()') mdi-window-close  
                                                            v-icon(size='18' v-if='showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                            v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                            v-col.pr-md-4(cols='12' md='6').my-1    
                                                div.d-flex.align-center.justify-space-between.input-has-label
                                                    .d-inline-flex.align-center.w-100(:class='isDetailReadonly ? "py-2" : " "')
                                                        label {{$t('GENERAL.MAIL')}}
                                                        v-text-field(v-if='!isDetailReadonly' v-model='orgDetail.email' solo :rules="formRule.emailRules" name="email" :readonly='!checkWiadvanceShow()')
                                                            template(v-slot:append)
                                                                v-icon.mr-1(size='18' color="green" v-if='!isDetailReadonly && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail(true)') icon-check
                                                                v-icon(size='18' color="red" v-if='!isDetailReadonly  && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail(1)') mdi-window-close 
                                                                v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                                        .d-flex.justify-space-between.w-100.ellipsis(v-else)
                                                            a.t-primary.ellipsis(:href='onMail(orgDetail.email)') {{ orgDetail.email }}
                                                            v-icon(size='18' v-if='checkWiadvanceShow() && isDetailReadonly && !loading_orgDeatil' v-hide-element @click='onEditDetail(1)') icon-edit
                                            v-col.pr-md-4(cols='12' md='6').my-1
                                                p.d-flex.align-center.input-has-label
                                                    label(for='type') {{$t('COMPANY_DETAIL.TYPE')}}
                                                    v-select#type.no-border(v-model="orgDetail.organization_type" solo :readonly='isDetailReadonly || !checkWiadvanceShow()' :items="orgtypeList" item-text="name" item-value="key" :class=' isDetailReadonly ? "remove-arrow" : ""' :menu-props='{closeOnClick:true}') 
                                                        template(v-slot:append-outer)
                                                            v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                            v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                            v-icon(size='18' v-if='checkWiadvanceShow() && showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                            v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                            v-col.pr-md-4(cols='12' md='6').my-1
                                                div.d-flex.align-center.justify-space-between.input-has-label(:class='isDetailReadonly ? "py-2" : " "')
                                                    .d-inline-flex.align-center.w-100
                                                        label(for='web') {{$t('COMPANY_DETAIL.WEB')}}
                                                        v-text-field#web(v-if='!isDetailReadonly' v-model='orgDetail.website' solo='solo' :rules='formRule.urlRules' :readonly='!checkWiadvanceShow()')
                                                            template(v-slot:append) 
                                                                v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                                v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                                v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                                        .d-flex.justify-space-between.w-100.ellipsis(v-else)
                                                            a.t-primary.ellipsis( :href='orgDetail.website' target='_blank') {{ orgDetail.website }}
                                                            v-icon(size='18' v-if='checkWiadvanceShow() && showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                            v-col.pr-md-4(cols='12' md='6').my-1 
                                                p.d-flex.align-center.input-has-label
                                                    label(for='industry') {{$t('COMPANY_DETAIL.INDUSTRY')}}
                                                    v-select#industry.no-border( v-model="orgDetail.industry" solo :readonly='isDetailReadonly || !checkWiadvanceShow()' :items="industryList" item-text="name" item-value="key" :class=' isDetailReadonly ? "remove-arrow" : ""' :menu-props='{closeOnClick:true}')
                                                        template(v-slot:append-outer)
                                                            v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                            v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                            v-icon(size='18' v-if='checkWiadvanceShow() && showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                            v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                            v-col.pr-md-4(cols='12' md='6').my-1
                                                p.d-flex.align-center.input-has-label
                                                    label(for='employee') {{$t('COMPANY_DETAIL.EMPLOYEE')}}
                                                    v-text-field#peoples(v-model='orgDetail.employee' solo='solo' :readonly='isDetailReadonly || !checkWiadvanceShow()' :rules='formRule.intRules')
                                                        template(v-slot:append)
                                                            v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                            v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                            v-icon(size='18' v-if='checkWiadvanceShow() && showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                            v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                            v-col.pr-md-4(cols='12' md='6').my-1
                                                p.d-flex.align-center.input-has-label
                                                    label(for='annual_revenue') {{$t('COMPANY_DETAIL.ANNUAL_REVENUE')}}
                                                    v-text-field(v-model='orgDetail.annual_revenue' solo='solo' v-show='!isDetailReadonly&&annualRevenueShow|!aRValidate' :readonly='!checkWiadvanceShow()' :rules='formRule.intRules' :ref="'editAmount'" @blur='showFormatAmount("annual_revenue")')
                                                        template(v-slot:append)
                                                            v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                            v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                            v-icon(size='18' v-if='showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                            v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                                    v-text-field(v-model='formatAR' solo='solo' @click='showEditAmount("annual_revenue")' @blur='showEditAmount("annual_revenue")' :readonly='true' v-show='!annualRevenueShow|!annualRevenueShow&&aRValidate')
                                                        template(v-slot:append)
                                                            v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                            v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                            v-icon(size='18' v-if='checkWiadvanceShow() && showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                            v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                            v-col.pr-md-4(cols='12' md='6').my-1
                                                p.d-flex.align-center.input-has-label
                                                    label(for='registered_capital') {{$t('COMPANY_DETAIL.REGISTERED_CAPITAL')}}
                                                    v-text-field(v-model='orgDetail.registered_capital' solo='solo' v-show='!isDetailReadonly&&registeredCapitalShow|!rCValidate' :readonly='!checkWiadvanceShow()' :rules='formRule.BigIntRules' :ref="'editBudget'" @blur='showFormatAmount("registered_capital")')
                                                        template(v-slot:append)
                                                            v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                            v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                            v-icon(size='18' v-if='showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                            v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                                    v-text-field(v-model='formatRC' solo='solo' @click='showEditAmount("registered_capital")' @blur='showEditAmount("registered_capital")' :readonly='true' v-show='!registeredCapitalShow|!registeredCapitalShow&&rCValidate')
                                                        template(v-slot:append)
                                                            v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                            v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                            v-icon(size='18' v-if='checkWiadvanceShow() && showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                            v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                            v-col.pr-md-4(cols='12' md='6').my-1
                                                p.d-flex.align-center.input-has-label
                                                    label(for='establish_date') {{$t('COMPANY_DETAIL.ESTABLISH_DATE')}}
                                                    v-text-field(v-if='isDetailReadonly || !checkWiadvanceShow()' readonly v-model='orgDetail.establish_date' solo )
                                                        template(v-slot:append)
                                                            v-icon(size='18' v-if='checkWiadvanceShow() && showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                    v-menu(v-else ref="menu" v-model="menu" :close-on-content-click="false" :z-index='100' transition="scroll-y-transition" offset-y min-width="auto") 
                                                        template(v-slot:activator="{ on, attrs }")
                                                            v-text-field( v-model='orgDetail.establish_date' solo  v-bind="attrs" v-on="on")
                                                                template(v-slot:append)
                                                                    v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                                    v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                                    v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                                        v-date-picker( v-model='orgDetail.establish_date' @input='menu = false'  no-title scrollable) 
                                            v-col.pr-md-4(cols='12' md='6').my-1
                                                p.d-flex.align-center.input-has-label
                                                    label(for='type') {{$t('COMPANY_DETAIL.CLOSING_DATE')}}
                                                    v-select#type.no-border(v-model="orgDetail.closing_date" solo multiple :readonly='isDetailReadonly || !checkWiadvanceShow()' :items="dateList" item-text="name" item-value="key" :class=' isDetailReadonly ? "remove-arrow" : ""' :menu-props='{closeOnClick:true}' ) 
                                                        template(v-slot:append-outer)
                                                            v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                            v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                            v-icon(size='18' v-if='checkWiadvanceShow() && showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                            v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                            v-col.pr-md-4(cols='12' md='6').my-1
                                                p.d-flex.align-center.input-has-label
                                                    label(for='type') {{$t('COMPANY_DETAIL.REGULAR_PAYMENT_DATE')}}
                                                    v-select#type.no-border(v-model="orgDetail.regular_payment_date" solo multiple :readonly='isDetailReadonly || !checkWiadvanceShow()' :items="dateList" item-text="name" item-value="key" :class=' isDetailReadonly ? "remove-arrow" : ""' :menu-props='{closeOnClick:true}') 
                                                        template(v-slot:append-outer)
                                                            v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                            v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                            v-icon(size='18' v-if='checkWiadvanceShow() && showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                            v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                            v-col.pr-md-4(cols='12' md='6').my-1
                                                p.d-flex.align-center.input-has-label
                                                    label(for='type') {{$t('COMPANY_DETAIL.PAYMENT_TERM')}}
                                                    v-select#type.no-border(v-if='isWiadvance()' v-model="orgDetail.payment_term" solo readonly :items="wiadvancePaymentTermList" item-text="name" item-value="key" :class=' "remove-arrow"' ) 
                                                    v-select#type.no-border(v-else v-model="orgDetail.payment_term" solo :readonly='isDetailReadonly' :items="paymentTermsList" item-text="name" item-value="key" :class=' isDetailReadonly ? "remove-arrow" : ""' :menu-props='{closeOnClick:true}') 
                                                        template(v-slot:append-outer)
                                                            v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='confirmEditDetail()') icon-check
                                                            v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='cancelEditDetail()') mdi-window-close  
                                                            v-icon(size='18' v-if='showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                            v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                            v-col.pr-md-4(cols='12' md='6').my-1 
                                                p.d-flex.align-center.input-has-label
                                                    label(for='industry') {{$t('COMPANY_DETAIL.RELATED_CAMPAIGN')}}
                                                    v-autocomplete#industry.no-border(v-model="orgDetail.primary_campaign_id" solo :readonly='isDetailReadonly || !checkWiadvanceShow()' :items="campaignList" item-text="name" item-value="id" :class=' isDetailReadonly ? "remove-arrow" : ""' :menu-props='{closeOnClick:true}')
                                                        template(v-slot:append-outer)
                                                            v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                            v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                            v-icon(size='18' v-if='checkWiadvanceShow() && showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                            v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                                        template(v-slot:selection='data') 
                                                            a.t-primary.ellipsis(:href="'/Campaign/'+ data.item.id" style='max-width: 250px;') {{ data.item.name }}
                                            v-col.pr-md-4(cols='12').my-1
                                                p.d-flex.align-center.input-has-label
                                                    label(for='describe') {{$t('COMPANY_DETAIL.DESCRIPTION')}}
                                                    v-textarea#describe.textarea-style(v-model='orgDetail.description' solo :readonly='isDetailReadonly || !checkWiadvanceShow()' no-resize)
                                                        template(v-slot:append)
                                                            v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                            v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                            v-icon.ml-1(size='18' v-if='checkWiadvanceShow() && showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                            v-progress-circular.ml-1(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                            v-row.mt-7.w-100(no-gutters)
                                                v-col.pr-md-4(cols='12' md='6').my-1
                                                    div.d-flex.align-center.justify-space-between.input-has-label.long-field-name
                                                        .d-inline-flex.align-center.w-100.overflow-hidden(:class='showDetailEditBtn ? "py-2" : " "' )
                                                            label
                                                                v-icon.d-inline.mr-2(size='21' color='t-lightgary') mdi-facebook
                                                                label.d-inline facebook
                                                            v-text-field(v-if='!showDetailEditBtn' v-model='orgDetail.facebook' solo :rules="formRule.urlRules" :readonly='isDetailReadonly || !checkWiadvanceShow()')
                                                                template(v-slot:append)
                                                                    v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                                    v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                                    v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                                            .d-flex.w-100.ellipsis(v-else)
                                                                a.t-primary.ellipsis(:href='orgDetail.facebook') {{ orgDetail.facebook }}
                                                                v-icon.ml-auto(size='18' v-if='checkWiadvanceShow()'  v-hide-element @click='onEditDetail()') icon-edit
                                                v-col.pr-md-4(cols='12' md='6').my-1
                                                    div.d-flex.align-center.justify-space-between.input-has-label.long-field-name
                                                        .d-inline-flex.align-center.w-100.overflow-hidden(:class='isDetailReadonly ? "py-2" : " "')
                                                            label
                                                                v-icon.d-inline.mr-2(size='21' color='t-lightgary') mdi-linkedin
                                                                label.d-inline linkedin
                                                            v-text-field(v-if='!isDetailReadonly' v-model='orgDetail.linkedin' solo :rules="formRule.urlRules" :readonly='isDetailReadonly || !checkWiadvanceShow()')
                                                                template(v-slot:append)
                                                                    v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                                    v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                                    v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                                            .d-flex.w-100.ellipsis(v-else)
                                                                a.ellipsis.t-primary( :href='orgDetail.linkedin') {{ orgDetail.linkedin }}
                                                                v-icon.ml-auto(size='18' v-if='checkWiadvanceShow()'  v-hide-element @click='onEditDetail()') icon-edit
                                                v-col.pr-md-4(cols='12' md='6').my-1
                                                    p.d-flex.align-center.input-has-label.long-field-name
                                                        label
                                                            v-icon.d-inline.mr-2(size='21' color='t-lightgary') fab fa-line
                                                            label.d-inline line
                                                        v-text-field(v-model='orgDetail.line_id' solo :readonly='isDetailReadonly || !checkWiadvanceShow()' :rules="formRule.contentLenRule50")
                                                            template(v-slot:append)
                                                                v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                                v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                                v-icon(size='18' v-if='checkWiadvanceShow() && showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                                v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                                v-col.pr-md-4(cols='12' md='6').my-1
                                                    p.d-flex.align-center.input-has-label.long-field-name
                                                        label
                                                            v-icon.d-inline.mr-2(size='21' color='t-lightgary') mdi-instagram
                                                            label.d-inline instagram
                                                        v-text-field(v-model='orgDetail.instagram_id' solo :readonly='isDetailReadonly || !checkWiadvanceShow()' :rules="formRule.contentLenRule50")
                                                            template(v-slot:append)
                                                                v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                                v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                                v-icon(size='18' v-if='checkWiadvanceShow() && showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                                v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                            v-row.mt-7.mb-4(no-gutters)
                                                v-col.pr-md-4(cols='12' md='6').my-1
                                                    div.d-flex.align-center.justify-space-between.input-has-label(:class='isDetailReadonly ? "py-2" : ""')
                                                        .d-inline-flex.align-center.w-100
                                                            label {{$t('COMPANY_DETAIL.ADDRESS')}}
                                                            v-text-field(v-if='!isDetailReadonly && !isWiadvance()' v-model='orgDetail.billing_address' solo)
                                                                template(v-slot:append)
                                                                    v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='confirmEditDetail()') icon-check
                                                                    v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='cancelEditDetail()') mdi-window-close  
                                                                    v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                                            .d-flex.w-100.ellipsis(v-if='isDetailReadonly && !isWiadvance()')
                                                                a.t-primary.ellipsis(:href='getGoogleMapSearchURL(orgDetail.billing_address)') {{ orgDetail.billing_address }}
                                                                v-icon.ml-auto(size='18' v-hide-element @click='onEditDetail()') icon-edit
                                                            .d-flex.w-100.ellipsis(v-if='isWiadvance()')
                                                                a.t-primary.ellipsis(:href='getGoogleMapSearchURL(orgDetail.billing_address)') {{ orgDetail.billing_address }}
                                                v-col.pr-md-4(cols='12' md='6').my-1
                                                    div.d-flex.align-center.justify-space-between.input-has-label(:class='isDetailReadonly ? "py-2" : ""')
                                                        .d-inline-flex.align-center.w-100
                                                            label {{$t('COMPANY_DETAIL.ADDRESS')+' 2'}}
                                                            v-text-field(v-if='!isDetailReadonly' v-model='orgDetail.sub_address' solo :readonly='isDetailReadonly || !checkWiadvanceShow()')
                                                                template(v-slot:append)
                                                                    v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                                    v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                                    v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                                            .d-flex.w-100.ellipsis(v-else)
                                                                a.t-primary.ellipsis(:href='getGoogleMapSearchURL(orgDetail.sub_address)') {{ orgDetail.sub_address }}
                                                                v-icon.ml-auto(size='18' v-if='checkWiadvanceShow()' v-hide-element @click='onEditDetail()') icon-edit
                                                v-col.pr-md-4(cols='12' md='6').my-1
                                                    p.d-flex.align-center.input-has-label
                                                        label {{$t('COMPANY_DETAIL.COUNTRY')}}
                                                        v-text-field(v-if='isWiadvance()' v-model='orgDetail.country' solo readonly  :rules='formRule.contentLenRule20')
                                                            //- template(v-slot:append)
                                                            //-     v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='confirmEditDetail()') icon-check
                                                            //-     v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='cancelEditDetail()') mdi-window-close  
                                                            //-     v-icon(size='18' v-if='showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                            //-     v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                                        v-text-field(v-else v-model='orgDetail.country' solo :readonly='isDetailReadonly'  :rules='formRule.contentLenRule20')
                                                            template(v-slot:append)
                                                                v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='confirmEditDetail()') icon-check
                                                                v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='cancelEditDetail()') mdi-window-close  
                                                                v-icon(size='18' v-if='showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                                v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                                v-col.pr-md-4(cols='12' md='6').my-1
                                                    p.d-flex.align-center.input-has-label
                                                        label {{$t('COMPANY_DETAIL.PROVINCE')}}
                                                        v-text-field(v-model='orgDetail.province' solo :readonly='isDetailReadonly || !checkWiadvanceShow()' :rules='formRule.contentLenRule50')
                                                            template(v-slot:append)
                                                                v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                                v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                                v-icon(size='18' v-if='checkWiadvanceShow() && showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                                v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                                v-col.pr-md-4(cols='12' md='6').my-1
                                                    p.d-flex.align-center.input-has-label
                                                        label {{$t('COMPANY_DETAIL.CITY')}}
                                                        v-text-field(v-if='isWiadvance()' v-model='orgDetail.city' solo readonly  :rules='formRule.contentLenRule50')
                                                        v-text-field(v-else v-model='orgDetail.city' solo :readonly='isDetailReadonly'  :rules='formRule.contentLenRule50')
                                                            template(v-slot:append)
                                                                v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='confirmEditDetail()') icon-check
                                                                v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='cancelEditDetail()') mdi-window-close  
                                                                v-icon(size='18' v-if='showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                                v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                                v-col.pr-md-4(cols='12' md='6').my-1
                                                    p.d-flex.align-center.input-has-label
                                                        label {{$t('COMPANY_DETAIL.ZIP_CODE')}}
                                                        v-text-field(v-if='isWiadvance()' v-model='orgDetail.zip_code' solo readonly :rules='formRule.contentLenRule10')
                                                        v-text-field(v-else v-model='orgDetail.zip_code' solo :readonly='isDetailReadonly' :rules='formRule.contentLenRule10')
                                                            template(v-slot:append)
                                                                v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='confirmEditDetail()') icon-check
                                                                v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil' @click='cancelEditDetail()') mdi-window-close  
                                                                v-icon(size='18' v-if='showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                                v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                                v-col.pr-md-4(v-if='isWiadvance()' cols='12' md='6').my-1
                                                    p.d-flex.align-center.input-has-label
                                                        label {{$t('COMPANY_DETAIL.BELONG_GROUP')}}
                                                        v-autocomplete#industry.no-border(v-model="orgDetail.belong_group" solo :readonly='isDetailReadonly || !checkWiadvanceShow()' :items="belongGroupList" item-text="name" item-value="key" :class=' isDetailReadonly ? "remove-arrow" : ""' :menu-props='{closeOnClick:true}')
                                                            template(v-slot:append)
                                                                v-icon.mr-1(size='18' color="green" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='confirmEditDetail()') icon-check
                                                                v-icon(size='18' color="red" v-if='!showDetailEditBtn && !loading_orgDeatil && checkWiadvanceShow()' @click='cancelEditDetail()') mdi-window-close  
                                                                v-icon(size='18' v-if='checkWiadvanceShow() && showDetailEditBtn' v-hide-element @click='onEditDetail()') icon-edit
                                                                v-progress-circular(size='18' v-if='loading_orgDeatil' indeterminate color='primary')
                                    customField(v-if='!loading' :Data='customFieldData' DataClass = 'Organization' :Editable='cFEditable')
                                // - note -
                                v-row.justify-md-end.mr-3.mt-3(no-gutters='no-gutters' v-if="isNoteTab")
                                    v-btn(@click='onAddNote()' width='120' height='32' color='green' plain border-0)
                                        v-icon.mr-1(size='14') icon-add
                                        span {{$t('COMPANY_DETAIL.ADD_NOTE')}} 
                                v-tab-item.pa-3(key='note' value='tab-3' :transition='false' :reverse-transition='false')
                                    .editor
                                    //- v-row.justify-end(no-gutters)
                                        v-btn(@click='onAddNote()' width='120' height='32' color='green' plain border-0)
                                            v-icon.mr-1(size='14') icon-add
                                            span {{$t('COMPANY_DETAIL.ADD_NOTE')}} 
                                    v-row.sheet-box.my-5(v-if='!hasType(timeLines, "NOTE")')
                                        v-col.d-flex.align-center.justify-center.pa-0( cols='12')
                                            v-sheet.d-flex.align-center.justify-center(rounded elevation="2" width='50%' height="60%")
                                                h5.ma-0.t-black {{$t('COMPANY_DETAIL.NO_NOTE')}} 
                                    v-timeline.mt-5.pt-0(dense align-top)
                                        template(v-for='(item, index) in timeLines')
                                            v-timeline-item(v-if="item.type === 'NOTE'" :key='index' color='success' :icon='getTimeLineIcon(item.type)' small right fill-dot)
                                                v-card.px-3.py-1(flat outlined :class='item.pinned == true ? "timeLine-note" : undefined')
                                                    v-row.justify-space-between.align-center(no-gutters)
                                                        v-col.f-smaller.t-lightgary.t-lightgary.d-flex.align-center(cols='10')
                                                            span.mr-3
                                                                | {{ item.timeConvert }} ・
                                                                | {{ item.owner }}
                                                        v-col.text-right(cols='1')
                                                            v-menu(bottom left)
                                                                template(v-slot:activator='{ on, attrs }')
                                                                    v-btn.ml-3(color='primary' dark v-bind='attrs' v-on='on' icon)
                                                                        v-icon(size='16')  icon-dot-3
                                                                v-list.pa-0
                                                                    v-list-item.px-0.text-center
                                                                        v-btn(@click='onPinNote(item)' text='text')
                                                                            v-icon.mr-1(v-if="item.pinned === true" size='10') fas fa-thumbtack
                                                                            span.ml-1 {{$t('GENERAL.PIN')}}
                                                                    v-list-item.px-0.text-center
                                                                        v-btn(@click='onEditNote(item)' text='text')
                                                                            span.ml-1 {{$t('GENERAL.EDIT')}}
                                                                    v-list-item.px-0.text-center
                                                                        v-btn(@click='onDeleteNote(item.id)' text='text')
                                                                            span.ml-1 {{$t('GENERAL.DELETE')}}
                                                        v-col(cols='12')
                                                            .timeLine-note-box(v-if='item.isMore_note')
                                                                vue-editor.can-select-text.v2e_no_border.v2e_post_max_height.ellipsis(ref='editor' v-model='item.content' :disabled='true' :editorOptions='editorSettings_no_tool' )
                                                                //- p.mb-1.ellipsis  {{ item.content }}
                                                            div(v-else)
                                                                vue-editor.can-select-text.v2e_no_border( v-model='item.content' :disabled='true' :editorOptions='editorSettings_no_tool' )
                                                                //- p.mb-1  {{ item.content }}
                                                        v-col.d-flex.justify-end(cols='12' v-if='checkMore(item.content,100)')
                                                            v-btn.pa-0(v-hide-element='false' v-if='item.isMore_note' @click='isMore(index, "NOTE")' color='primary' text) MORE
                                                            v-btn.pa-0(v-hide-element='false' v-else @click='isMore(index, "NOTE")' color='primary' text) LESS
                                // - News -
                                //- v-tab-item.pa-3(key='news' value='tab-4' :transition='false' :reverse-transition='false')
                                //-     newsDisplay()
                                // - Opportunities
                                v-tab-item.pa-3(key='oppties' value='tab-5' :transition='false' :reverse-transition='false')
                                    v-row.sheet-box.my-5(v-if='!haveOpptyList')
                                        v-col.d-flex.align-center.justify-center.pa-0( cols='12')
                                            v-sheet.d-flex.align-center.justify-center(rounded elevation="2" width='50%' height="60%")
                                                h5.ma-0.t-black {{$t('COMPANY_DETAIL.NO_DEAL')}} 
                                    .contact-detail-table.scroll-x.pb-0(v-else)
                                        .data-area
                                            v-data-table.height_100.table_in_tab( :headers='dealsHeaders' :header-props="{sortIcon: 'mdi mdi-arrow-up'}" :items='orgDetail.opportunity_set' :search='searchDeals' :items-per-page='itemPerPage' :page.sync='page' @page-count='pageCount = $event' multi-sort height='100%' hide-default-footer='hide-default-footer')
                                                template(v-slot:item.name='{ item }')
                                                    v-row(no-gutters)
                                                        v-col(cols='2').d-none.d-md-flex
                                                            v-system-bar(:color='item.stage_light_color.color')
                                                        v-col(cols='12' md='10').ellipsis.d-flex.align-center
                                                            a.pl-2.ellipsis(:title='item.name' :href='"/Deal/" + item.id') {{ item.name }}
                                                template(v-slot:item.closed_reason='{ item }')
                                                    v-chip.my-2.text-white(v-if='item.closed_reason == 1' color='green' small) Won
                                                    v-chip.my-2.text-black(v-else-if='item.closed_reason == null || item.closed_reason == " "'  small) Open
                                                    v-chip.my-2.text-white(v-else color='red' small) Lose
                                                template(v-slot:item.client='{ item }')
                                                    .ellipsis
                                                        a(:title='item.oppty_org.name' v-if='item.oppty_org' :href='"/Account/" + item.oppty_org.id') {{ item.oppty_org.name }}
                                                        a(:title='item.oppty_contact.__chineseName__' v-if='item.oppty_contact' :href='"/Contacts/" + item.oppty_contact.id') {{ item.oppty_contact.__chineseName__ }}
                                                template(v-slot:item.current_stage.sequence_number='{ item }')
                                                    .ellipsis
                                                        span(:title='item.current_stage.stage_name' ) {{ item.current_stage.stage_name }}
                                                template(v-slot:item.amount='{ item }')
                                                    .ellipsis
                                                        span(:title='getFormatAmount(item.amount)' v-if='item.amount') $ {{ getFormatAmount(item.amount) }}
                                                template(v-slot:item.expected_close_date='{ item }')
                                                    .ellipsis
                                                        span(:title='item.expected_close_date' v-if='item.expected_close_date') {{ item.expected_close_date }}
                                                template(v-slot:item.owner_name='{ item }')
                                                    .ellipsis
                                                        a.t-primary(:title='item.owner.last_name +" "+ item.owner.first_name' :href='onMail(item.owner.email)') {{ item.owner.last_name +' '+ item.owner.first_name }}
                                                template(v-slot:item.active='{ item }')
                                                    v-btn( icon='icon' @click='showToDealDialog(item)')
                                                        v-icon(size='18') icon-chatmoney
                                                    v-btn(v-if='checkWiadvanceShow()' :disabled='item.closed_reason >= 1' icon='icon' @click='onDeleteDeal(item)')
                                                        v-icon(size='18') icon-remove
                                            v-pagination.py-1.mb-3(v-model='page' :length='pageCount' circle :total-visible="10") 
                                v-tab-item.pa-3(key='cases' value='tab-6' :transition='false' :reverse-transition='false')
                                    casesTable(:cases='openCases')
                                // - documents -
                                v-row.justify-md-end.mr-3.mt-3(no-gutters='no-gutters' v-if="isdocumentTab")
                                    v-btn(@click='onDelDocument()' width='120' height='32' color='red' plain border-0 v-if="isDelDocument")
                                        v-icon.mr-1(size='14') icon-remove
                                        span {{$t('DOCUMENT.DEL')}}
                                    v-btn(@click='onAddDocument()' width='120' height='32' color='green' plain border-0)
                                        v-icon.mr-1(size='14') icon-add
                                        span {{$t('DOCUMENT.ADD')}}
                                v-tab-item.pa-3(key='documents' value='tab-7' :transition='false' :reverse-transition='false')
                                    documentsTable(class_name='Organization' :target_id='target_id' @emitDocumentsList='selectDocumentsList' :isDel='openDelDocumentDialog' :addDocDialog ='isAddDoucment' @emitDocDialog='onEmitDocDialog' )
                                // - activity -
                                v-row.justify-md-end.mr-3.mt-3(no-gutters='no-gutters' v-if="isActivityTab")
                                    .btn-switch.ml-3.mb-3
                                        v-btn(v-hide-element='false' :ripple='false' @click='activity_mode = "list"' width='30%' height='24' :color=" activity_mode == 'list'? 'primary':'white'"  depressed tile :dark='activity_mode != "list"')
                                            v-icon(size='14') icon-list
                                        v-btn(v-hide-element='false' :ripple='false' @click='activity_mode = "calender"' width='30%' height='24' :color=" activity_mode == 'calender' ? 'primary' : 'white' " depressed tile :dark='activity_mode != "calender"')
                                            v-icon.icon-calendar.mt-1(size='16')
                                    v-btn(@click='onAddActivity()' width='120' height='32' color='green' plain border-0)
                                        v-icon.mr-1.mb-1(size='16') icon-add
                                        span.mb-1 {{$t('ACTIVITY.ADD')}}
                                v-tab-item.pa-3(key='activity' value='tab-8' :transition='false' :reverse-transition='false')
                                    activitiesTable(:isAddActivity='isAddActivity' @emitAddActivity='onEmitAddActivity' :target_id='target_id' :mode='activity_mode' :target_name='orgDetail.name' ,from_page='org')
                                // - end_customer - For INDUSTRY IT ONLY
                                v-row.justify-md-end.mr-1.mt-1(no-gutters='no-gutters' v-if="isEndCustomerTab")
                                    v-btn(v-if="end_customer_type!=''&&checkWiadvanceShow()" @click='onAddEndCustomer()' width='120' height='38' color='green' plain border-0)
                                        v-icon.mr-1(size='14') icon-add
                                        span {{$t('END_CUSTOMER.ADD')}}
                                    v-col(cols="4")
                                        v-select(v-model='end_customer_type' :items='end_customer_type_tabs' item-value='key' item-text='name' height='32' flat dense solo background-color='#F0F0F0')
                                v-tab-item.pa-3(key='end_customer' value='tab-9' :transition='false' :reverse-transition='false')
                                    endCustomerTable(:organization_id='target_id' :type_key='end_customer_type' :end_customer_definitions='end_customer_type_tabs' :addEndCustomerDialog ='isAddEndCustomer' @emitEndCustomerDialog='onEmitEndCustomerDialog')
                    v-col.pt-4.pt-md-0.pl-md-4.min-pad-scroll(cols='12' md='4')
                        v-card.contact-card(flat)
                            v-card-title.d-flex.justify-space-between.align-center.px-3.py-2
                                .d-flex.align-center.my-0
                                    .cube-icon.small.bg-primary.mr-2
                                        v-icon(size='21' color='white') mdi-account
                                    span {{$t('MAINCONTACTS.TITLE')}} 
                                        v-badge(v-if="accountContactsAmount > 1" :content="accountContactsAmount" float color="#007bff")
                                v-btn.pa-0(v-hide-element='false' @click='onMainContacts(accountContacts)' color='primary' text) MORE
                            v-card-text.py-0.mb-4
                                v-row.sheet-box.my-5(v-if='!haveContact')
                                    v-col.d-flex.align-center.justify-center.pa-0( cols='12')
                                        v-sheet.d-flex.align-center.justify-center(rounded elevation="2" width='50%' height="60%")
                                            h5.ma-0.t-black {{$t('COMPANY_DETAIL.NO_CONTACT')}} 
                                div(v-else)
                                    v-list-item.px-0.py-2(v-for='(item,index) in accountContacts' :key='item.id' v-if='index == 0')
                                        v-list-item-avatar.ma-0.mr-3(v-if='index == 0' color='blue-grey lighten-5' size='40')
                                            span.mx-auto(v-if="item.image === null") {{ item.last_name }}
                                            img(v-else :src='item.image' :alt='item.last_name')
                                        v-list-item-content(v-if='index == 0')
                                            v-list-item-title.d-flex.justify-space-between.align-Start
                                                a.ellipsis.f-text-highlight.text-subtitle-2.mb-0(:href="'/Contacts/'+item.id" v-if='item.first_name != null') {{ item.last_name+' '+item.first_name  }}
                                                a.f-text-highlight.text-subtitle-2.mb-0(:href="'/Contacts/'+item.id" v-else) {{ item.last_name }}
                                                span.job-label.ellipsis(v-if='!!item.organizationcontacts_set[0].position')  {{ item.organizationcontacts_set[0].position }}
                                            v-list-item-subtitle
                                                p.my-2(v-if='!!item.mobile_phone')
                                                    v-icon.mr-1(size='14' color='gary') icon-cell
                                                    a.t-black(:href='onCall(item.mobile_phone)') {{ item.mobile_phone }}
                                                p.ma-0(v-if='!!item.email')
                                                    v-icon.mr-1(size='14' color='gary') icon-mail
                                                    a.t-black(:href='onMail(item.email)') {{ item.email }}
                        // - Time line -
                        v-card.contact-card(flat).mt-3
                            v-card(flat)
                                v-card-title.d-flex.justify-space-between.align-center.px-3.py-2
                                    .d-flex.align-center.my-0
                                        .cube-icon.small.bg-pink.mr-2
                                            v-icon(size='21' color='white') mdi-clock
                                        span {{$t('COMPANY_DETAIL.TIMELINE')}}
                                v-card-text.py-0
                                    v-row.sheet-box.my-5(v-if='timeLines.length == 0')
                                        v-col.d-flex.align-center.justify-center.pa-0( cols='12')
                                            v-sheet.d-flex.align-center.justify-center(rounded elevation="2" width='50%' height="60%")
                                                h5.ma-0.t-black {{$t('COMPANY_DETAIL.NO_TIMELINE')}}
                                    v-tabs.borderBtn-tabs(v-else height='32' background-color='white' hide-slider show-arrows centered)
                                        v-tab(v-if="!loading" v-for='item in timeLineType' :key='item.key' :id='`Tlt-${item.key}`'  @click='onChangeTltSelected' :class='changeSelectedColor(item.key)')
                                            | {{ item.name }}
                                    div.pa-3.pt-5.pt-4.scrollTimeLine(:style='timeline_max_height')
                                        v-timeline.pt-0(dense align-top)
                                            v-timeline-item(v-for='(item, index) in showTimelines' :key='index' :color='item.type == "DUE_ACTIVITY" ? "#FFD306" : "success"' :icon='getTimeLineIcon(item.type)' small right fill-dot v-if='item.show == true && item.show_index<timeline_count')
                                                // Time Line Item - DUE ACTIVITY
                                                v-card.px-3.py-1(v-if="item.type === 'DUE_ACTIVITY'" flat outlined :class='"timeLine-note"')
                                                    v-row.justify-space-between.align-center(no-gutters)
                                                        //- v-col.f-smaller.t-lightgary.t-lightgary.d-flex.align-center(cols='10')
                                                        //-     span.mr-3
                                                        //-         | {{ item.timeConvert }} ・
                                                        //-         | {{ item.changed_by }}
                                                        v-col(cols='12')
                                                            p(v-if="item.is_due < 0").mb-1.t-black  {{ item.type_name }} {{$t("Bower_Title.Activity")}} {{ item.subject }} {{$t("DEAL_DETAIL.SOON_DUE")}}{{(item.is_due)*-1}}{{$t("DEAL_DETAIL.SOON_DUE_1")}}
                                                            p(v-else-if="item.is_due == 0").mb-1.t-black  {{ item.type_name }} {{$t("Bower_Title.Activity")}} {{ item.subject }} {{$t("DEAL_DETAIL.SOON_DUE")}}{{$t("DEAL_DETAIL.SOON_DUE_4")}}
                                                            p(v-else).mb-1.t-black  {{ item.type_name }} {{$t("Bower_Title.Activity")}} {{ item.subject }} {{$t("DEAL_DETAIL.SOON_DUE_2")}}{{item.is_due}}{{$t("DEAL_DETAIL.SOON_DUE_3")}}
                                                // Time Line Item - FIELDHISTORY
                                                v-card.px-3.py-1(v-if="item.type === 'FIELDHISTORY' || item.type === 'ACTIVITY_FIELDHISTORY'" flat outlined)
                                                    v-row.justify-space-between.align-center(no-gutters)
                                                        v-col.f-smaller.t-lightgary.t-lightgary.d-flex.align-center(cols='10')
                                                            span.mr-3
                                                                | {{ item.timeConvert }} ・
                                                                | {{ item.changed_by }}
                                                        v-col(cols='12')
                                                            p.mb-1.t-black  {{ item.content }}
                                                // - Time Line Item- NOTE -
                                                v-card.px-3.py-1(v-if="item.type === 'NOTE'" flat outlined :class='item.pinned == true ? "timeLine-note" : ""')
                                                    v-row.justify-space-between.align-center(no-gutters)
                                                        v-col.f-smaller.t-lightgary.t-lightgary.d-flex.align-center(cols='10')
                                                            span.mr-3
                                                                | {{ item.timeConvert }} ・
                                                                | {{ item.owner }}
                                                        v-col.text-right(cols='1')
                                                            v-menu(bottom left)
                                                                template(v-slot:activator='{ on, attrs }')
                                                                    v-btn.ml-3(color='primary' dark v-bind='attrs' v-on='on' icon)
                                                                        v-icon(size='16')  icon-dot-3
                                                                v-list.pa-0
                                                                    v-list-item.px-0.text-center
                                                                        v-btn(@click='onPinNote(item)' text='text')
                                                                            v-icon.mr-1(v-if="item.pinned === true" size='10') fas fa-thumbtack
                                                                            span.ml-1 {{$t('GENERAL.PIN')}}
                                                                    v-list-item.px-0.text-center
                                                                        v-btn(@click='onEditNote(item)' text='text')
                                                                            span.ml-1 {{$t('GENERAL.EDIT')}}
                                                                    v-list-item.px-0.text-center
                                                                        v-btn(@click='onDeleteNote(item.id)' text='text')
                                                                            span.ml-1 {{$t('GENERAL.DELETE')}}
                                                        v-col(cols='12')
                                                            .tab-note-box(v-if='item.isMore_timeLineAll')
                                                                vue-editor.can-select-text.v2e_no_border.v2e_post_max_height.ellipsis(ref='editor' v-model='item.content' :disabled='true' :editorOptions='editorSettings_no_tool' )
                                                                //- p.mb-1.ellipsis  {{ item.content }}
                                                            div(v-else)
                                                                vue-editor.can-select-text.v2e_no_border( v-model='item.content' :disabled='true' :editorOptions='editorSettings_no_tool' )
                                                                //- p.mb-1  {{ item.content }}
                                                        v-col.d-flex.justify-end(cols='12' v-if='checkMore(item.content,300)')
                                                            v-btn.pa-0(v-hide-element='false' v-if='item.isMore_timeLineAll' @click="isMore(index, 'timeLineAll')" color='primary' text) MORE
                                                            v-btn.pa-0(v-hide-element='false' v-else @click="isMore(index, 'timeLineAll')" color='primary' text) LESS
                                        v-divider.pa-0.ma-0(id='timeline_btm' style='border-color:#00000000;')
                                                    //- // - Time Line Item - Mail  -
                                                    //- v-card.px-3.py-1(v-if="item.type === 'EMAIL'" flat outlined)
                                                    //-     v-row.justify-space-between.align-center(no-gutters)
                                                    //-         v-col.d-flex.align-center(cols='10')
                                                    //-             v-card-subtitle.pa-0.t-black
                                                    //-                 | {{ item.email_subject }}
                                                    //-         v-col.text-right(cols='1')
                                                    //-             v-menu(bottom left)
                                                    //-                 template(v-slot:activator='{ on, attrs }')
                                                    //-                     v-btn(color='primary' dark v-bind='attrs' v-on='on' icon)
                                                    //-                         v-icon.pr-3(size='16')  icon-dot-3
                                                    //-                 v-list.pa-0
                                                    //-                     v-list-item.px-0.text-center
                                                    //-                         v-btn(@click='' text='text')
                                                    //-                             span.ml-1 釘選
                                                    //-                     v-list-item.px-0.text-center
                                                    //-                         v-btn(text='text')
                                                    //-                             span.ml-1 回信
                                                    //-                     v-list-item.px-0.text-center
                                                    //-                         v-btn(@click='onDetele(item)' text='text')
                                                    //-                             span.ml-1 刪除
                                                    //-         v-col.f-smaller.t-lightgary.d-flex.align-center(cols='12')
                                                    //-             span.mr-3
                                                    //-                 | {{ item.time }} 
                                                    //-         v-col(cols='12 mt-2')
                                                    //-             p.mb-1  {{ item.email_body }}
                                                    //-     v-row.justify-space-between.align-center.mt-3(no-gutters)
                                                    //-         v-col.d-flex.align-center(cols='6')
                                                    //-             //- v-icon.mr-2(size='16') mdi-eye
                                                    //-             a.t-primary(:href='onCall()' target='_blank') {{ 'item.contact' }}
                                                    //-         v-col.text-right(cols='6')
                                                    //-             //- v-icon.mr-2(size='16') mdi-link-variant 
                                                    //-             a.t-primary(:href='onCall()' target='_blank') {{ 'item.oppty' }}
                                        //- // - Time Line - mail -
                                        //- //- v-tab-item.pa-3.pt-5(key='EMAIL' value='tab-2' :transition='false' :reverse-transition='false')
                                        //- //-     v-timeline.pt-0(dense align-top)
                                        //- //-         template(v-for='(item, index) in timeLines')
                                        //- //-             v-timeline-item(v-if="item.type === 'EMAIL'" :key='index' color='success' :icon='getTimeLineIcon(item.type)' small right fill-dot)
                                        //- //-                 v-card.px-3.py-1(v-if="item.type === 'EMAIL'" flat outlined)
                                        //- //-                     v-row.justify-space-between.align-center(no-gutters)
                                        //- //-                         v-col.d-flex.align-center(cols='10')
                                        //- //-                             v-card-subtitle.pa-0.t-black
                                        //- //-                                 | {{ item.email_subject }}
                                        //- //-                         v-col.text-right(cols='1')
                                        //- //-                             v-menu(bottom left)
                                        //- //-                                 template(v-slot:activator='{ on, attrs }')
                                        //- //-                                     v-btn(color='primary' dark v-bind='attrs' v-on='on' icon)
                                        //- //-                                         v-icon.pr-3(size='16')  icon-dot-3
                                        //- //-                                 v-list.pa-0
                                        //- //-                                     v-list-item.px-0.text-center
                                        //- //-                                         v-btn(@click='' text='text')
                                        //- //-                                             span.ml-1 釘選
                                        //- //-                                     v-list-item.px-0.text-center
                                        //- //-                                         v-btn(text='text')
                                        //- //-                                             span.ml-1 回信
                                        //- //-                                     v-list-item.px-0.text-center
                                        //- //-                                         v-btn(@click='onDetele(item)' text='text')
                                        //- //-                                             span.ml-1 刪除
                                        //- //-                         v-col.f-smaller.t-lightgary.d-flex.align-center(cols='12')
                                        //- //-                             span.mr-3
                                        //- //-                                 | {{ item.time }} 
                                        //- //-                         v-col(cols='12 mt-2')
                                        //- //-                             p.mb-1  {{ item.email_body }}
                                        //- //-                     v-row.justify-space-between.align-center.mt-3(no-gutters)
                                        //- //-                         v-col.d-flex.align-center(cols='6')
                                        //- //-                             //- v-icon.mr-2(size='16') mdi-eye
                                        //- //-                             a.t-primary(:href='onCall()' target='_blank') {{ 'item.contact' }}
                                        //- //-                         v-col.text-right(cols='6')
                                        //- //-                             //- v-icon.mr-2(size='16') mdi-link-variant 
                                        //- //-                             a.t-primary(:href='onCall()' target='_blank') {{ 'item.oppty' }}                                                    
                                        //- // - Time Line - note -
                                        //- v-tab-item.pa-3.pt-5(key='NOTE' value='tab-3' :transition='false' :reverse-transition='false')
                                        //-     v-timeline.pt-0(dense align-top v-if='hasType(timeLines, "NOTE")')
                                        //-         template(v-for='(item, index) in timeLines')
                                        //-             v-timeline-item(v-if="item.type === 'NOTE'" :key='index' color='success' :icon='getTimeLineIcon(item.type)' small right fill-dot)
                                        //-                 v-card.px-3.py-1(v-if="item.type === 'NOTE'" flat outlined :class='item.pinned == true ? "timeLine-note" : ""')
                                        //-                     v-row.justify-space-between.align-center(no-gutters)
                                        //-                         v-col.f-smaller.t-lightgary.t-lightgary.d-flex.align-center(cols='10')
                                        //-                             span.mr-3
                                        //-                                 | {{ item.timeConvert }} ・
                                        //-                                 | {{ item.owner }}
                                        //-                         v-col.text-right(cols='1')
                                        //-                             v-menu(bottom left)
                                        //-                                 template(v-slot:activator='{ on, attrs }')
                                        //-                                     v-btn.ml-3(color='primary' dark v-bind='attrs' v-on='on' icon)
                                        //-                                         v-icon(size='16')  icon-dot-3
                                        //-                                 v-list.pa-0
                                        //-                                     v-list-item.px-0.text-center
                                        //-                                         v-btn(@click='onPinNote(item)' text='text')
                                        //-                                             v-icon.mr-1(v-if="item.pinned === true" size='10') fas fa-thumbtack
                                        //-                                             span {{$t('GENERAL.PIN')}}
                                        //-                                     v-list-item.px-0.text-center
                                        //-                                         v-btn(@click='onEditNote(item)' text='text')
                                        //-                                             span.ml-1 {{$t('GENERAL.EDIT')}}
                                        //-                                     v-list-item.px-0.text-center
                                        //-                                         v-btn(@click='onDeleteNote(item.id)' text='text')
                                        //-                                             span.ml-1 {{$t('GENERAL.DELETE')}}
                                        //-                         v-col(cols='12')
                                        //-                             .timeLine-note-box(v-if='item.isMore_timeLineNote')
                                        //-                                 p.mb-1.ellipsis  {{ item.content }}
                                        //-                             div(v-else)
                                        //-                                 p.mb-1  {{ item.content }}
                                        //-                         v-col.d-flex.justify-end(cols='12' v-if='item.content.length > 100')
                                        //-                             v-btn.pa-0(v-if='item.isMore_timeLineNote' @click='isMore(index, "timeLineNote")' color='primary' text) MORE
                                        //-                             v-btn.pa-0(v-else @click="isMore(index, 'timeLineNote')" color='primary' text) LESS
                                        //-     v-row.sheet-box.my-5(v-else)
                                        //-         v-col.d-flex.align-center.justify-center.pa-0( cols='12')
                                        //-             v-sheet.d-flex.align-center.justify-center(rounded elevation="2" width='50%' height="60%")
                                        //-                 h5.ma-0.t-black {{$t('COMPANY_DETAIL.NO_NOTE')}}
                                        //- // - Time Line - FIELDHISTORY -
                                        //- v-tab-item.pa-3.pt-5(key='FIELDHISTORY' value='tab-4' :transition='false' :reverse-transition='false')
                                        //-     v-timeline.pt-0(dense align-top v-if='hasType(timeLines, "FIELDHISTORY")')
                                        //-         template(v-for='(item, index) in timeLines')
                                        //-             v-timeline-item(v-if="item.type === 'FIELDHISTORY'" :key='index' color='success' :icon='getTimeLineIcon(item.type)' small right fill-dot)
                                        //-                     v-card.px-3.py-1(v-if="item.type === 'FIELDHISTORY'" flat outlined)
                                        //-                         v-row.justify-space-between.align-center(no-gutters)
                                        //-                             v-col.f-smaller.t-lightgary.t-lightgary.d-flex.align-center(cols='10')
                                        //-                                 span.mr-3
                                        //-                                     | {{ item.timeConvert }} ・
                                        //-                                     | {{ item.changed_by }}
                                        //-                             v-col(cols='12')
                                        //-                                 p.mb-1.t-black  {{ item.content }}    
                                        //-     v-row.sheet-box.my-5(v-else)
                                        //-         v-col.d-flex.align-center.justify-center.pa-0( cols='12')
                                        //-             v-sheet.d-flex.align-center.justify-center(rounded elevation="2" width='50%' height="60%")
                                        //-                 h5.ma-0.t-black {{$t('GENERAL.NO_FIELDHISTORY')}}
                                        //- // - Time Line activity
                                        //- v-tab-item.pa-3.pt-5(key='ACTIVITY' value='tab-5' :transition='false' :reverse-transition='false')
                                        //-     v-row.sheet-box.my-5(v-if='!hasType(activityTimeline, "ACTIVITY_FIELDHISTORY")')
                                        //-         v-col.d-flex.align-center.justify-center.pa-0( cols='12')
                                        //-             v-sheet.d-flex.align-center.justify-center(rounded elevation="2" width='50%' height="60%")
                                        //-                 h5.ma-0.t-black {{$t('DEAL_DETAIL.NO_ACTIVITY_CHANGE')}}
                                        //-     v-timeline.pt-0(v-else dense align-top)
                                        //-         template(v-for='(item, index) in timeLines')
                                        //-             v-timeline-item(v-if="item.type === 'DUE_ACTIVITY'" :key='item.id' color='#FFDC35' icon='mdi-bell-ring' small right fill-dot)
                                        //-                 v-card.px-3.py-1(v-if="item.type === 'DUE_ACTIVITY'" flat outlined class="timeLine-note")
                                        //-                     v-row.justify-space-between.align-center(no-gutters)
                                        //-                         v-col(cols='12')
                                        //-                             p(v-if="item.is_due < 0").mb-1.t-black  {{ item.type_name }} {{$t("Bower_Title.Activity")}} {{ item.subject }} {{$t("DEAL_DETAIL.SOON_DUE")}}{{(item.is_due)*-1}}{{$t("DEAL_DETAIL.SOON_DUE_1")}}
                                        //-                             p(v-else-if="item.is_due == 0").mb-1.t-black  {{ item.type_name }} {{$t("Bower_Title.Activity")}} {{ item.subject }} {{$t("DEAL_DETAIL.SOON_DUE")}}{{$t("DEAL_DETAIL.SOON_DUE_4")}}
                                        //-                             p(v-else).mb-1.t-black  {{ item.type_name }} {{$t("Bower_Title.Activity")}} {{ item.subject }} {{$t("DEAL_DETAIL.SOON_DUE_2")}}{{item.is_due}}{{$t("DEAL_DETAIL.SOON_DUE_3")}}
                                        //-         template(v-for='(item, index) in activityTimeline')
                                        //-             v-timeline-item(v-if="item.type === 'ACTIVITY_FIELDHISTORY'" :key='index' color='success' icon='icon-calendar' small right fill-dot)
                                        //-                 v-card.px-3.py-1(v-if="item.type === 'ACTIVITY_FIELDHISTORY' " flat outlined)
                                        //-                     v-row.justify-space-between.align-center(no-gutters)
                                        //-                         v-col.f-smaller.t-lightgary.t-lightgary.d-flex.align-center(cols='10')
                                        //-                             span.mr-3
                                        //-                                 | {{ item.timeConvert }} ・
                                        //-                                 | {{ item.changed_by }}
                                        //-                         v-col(cols='12')
                                        //-                             p.mb-1.t-black  {{ item.content }}
        v-dialog(v-model='changeOwnDialog' max-width='500' v-if='changeOwnDialog')
            change-own(@emitChangeOwnDialog='onEmitChangeOwnDialog' :owner-data='changeOwnData' :other-data='otherData' change='accounts')
        v-dialog(v-model='editAccountDialog' max-width='500')
            edit-account(@emitEditAccountDialog='onEmitEditAccountDialog' :account-data='edtorAccountData')
        v-dialog(v-model='mainContactsDialog' width='1100' content-class='contact-dialog' v-if='mainContactsDialog')
            main-contacts(@emitMainContactsDialog='onEmitMainContactsDialog' @MainContact='onEmitMainContactMessage($event)' :contact-data='mainContactData')
        v-dialog(v-model='activityDialog' width='470' data-app='true')
            activity-dialog(@emitActivityDialog='onEmitActivityDialog')
        v-dialog(v-model='addDealDialog' max-width='600' v-if='addDealDialog')
            add-deal(@emitAddDealDialog='onEmitAddDealDialog' @emitNewDealData='onEmitNewDealData' :add-deal='addDealData')
        v-dialog(v-model='toDealDialog' max-width='1200' v-if='toDealDialog')
            to-deal(@emitToDealDialog='onEmitToDealDialog' :oppty-data='opptyData')
        v-dialog(v-model='messageDialog' width='360' content-class='statusDialog')
            message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
        v-dialog(v-model='successDialog' width='360' content-class='statusDialog')
            success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
        v-dialog(v-model='errorDialog' width='360' content-class='statusDialog')
            error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
        v-dialog(v-model='addNoteDialog' max-width='500' v-if='addNoteDialog')
            add-note(@emitAddNoteDialog='onEmitAddNoteDialog' @emitAddNoteData='onEmitAddNoteData' :note-data='noteData')
        v-dialog(v-model='editNoteDialog' max-width='500' v-if='editNoteDialog')
            edit-note(@emitEditNoteDialog='onEmitEditNoteDialog' :note-data='noteData')
        v-dialog(v-model='addCaseDialog' max-width='600' v-if='addCaseDialog')
            add-case(@emitAddCaseDialog='onEmitAddCaseDialog' @emitNewCaseData='onEmitNewCaseData' :add-case='addCaseData')
</template>

<script>
    import { VueEditor } from "vue2-editor";
    import _ from 'lodash';
    // dialog
    import changeOwn from '@/components/Dialog/changeOwn';
    import editAccount from '@/components/Dialog/Account/editAccount';
    import newsDisplay from '@/components/Common/newsDisplay';
    import mainContacts from '@/components/Dialog/Contact/mainContacts';
    import activityDialog from '@/components/Dialog/activityDialog';
    import messageDialog from '@/components/Dialog/messageDialog';
    import successDialog from '@/components/Dialog/successDialog';
    import errorDialog from '@/components/Dialog/errorDialog';
    import addDeal from '@/components/Dialog/Deal/addDeal';
    import toDeal from '@/components/Dialog/Deal/toDeal';
    import addNote from '@/components/Dialog/addNote';
    import editNote from '@/components/Dialog/editNote';
    import addCase from '@/components/Dialog/Case/addCase';
    import documentsTable from "@/components/Common/documentsTable";
    import activitiesTable from "@/components/Common/activitiesTable";
    import endCustomerTable from "@/components/Common/endCustomerTable";
    // service
    import NoteDataService from '../services/NoteDataService'
    import CaseDataService from '../services/CaseDataService'
    import OpportunityDataService from "@/services/OpportunityDataService";
    import OrganizationDataService from "../services/OrganizationDataService";
    import ActivityDataService from '../services/ActivityDataService';
    import PersonalSettingService from '../services/PersonalSettingService';
    import CampaignDataService from "@/services/CampaignDataService";
    import PreferenceService from "@/services/PreferenceService";
    import getCustomerCodeListOptions from "@/views-wiadvance/getCustomerCodeListOptions";
    import checkCustomerCodeRepeat from "@/views-wiadvance/checkCustomerCodeRepeat";
    // array
    import forecast_category_List from "@/array/the_forecastCategoryList";
    import wiadvancePaymentTermList from "@/array/the_wiadvancePaymentTermList";
    import paymentTermsList from "@/array/the_paymentTermsList";
    import industryList from "@/array/the_IndustryList";
    import orgtypeList from "@/array/the_OrgtypeList";
    import belongGroupList from "@/array/the_belongGroupList";
    // other
    import customField from "@/components/Common/customField";
    import caseCard from "@/components/Common/caseCard";
    import opptyCard from "@/components/Common/opptyCard";
    import casesTable from "@/components/Common/casesTable";
    import i18n from '/common/plugins/vue-i18n.js';
    import followBtn from "@/components/Common/followBtn";

    export default {
        components: {
            editAccount,
            newsDisplay,
            changeOwn,
            mainContacts,
            activityDialog,
            messageDialog,
            successDialog,
            errorDialog,
            addDeal,
            toDeal,
            addNote,
            editNote,
            VueEditor,
            customField,
            caseCard,
            opptyCard,
            casesTable,
            addCase,
            documentsTable,
            activitiesTable,
            endCustomerTable,
            followBtn,
        },
        data() {
            return {
                // vue editor
                editorSettings_no_tool: {
                    modules: {
                        imageResize: false,
                        toolbar:false
                        },
                },
                campaignList:[],            
                loading_orgDeatil: false,
                customFieldData:{}, 
                valid: true,
                loading: true,
                mainEditor: '',
                stepContent: true,
                tab: null,
                orgDetail: {},
                changeOwnData: {},
                otherData: {},
                orgImage: null,
                userphoto: null,                
                timeLines:[],
                showTimelines:[],
                industryList: industryList,
                customer_code_List: [],
                orgtypeList: orgtypeList,
                forecast_category_List: forecast_category_List,
                menu: false,      
                tabs: [{
                        id: 1,
                        key: 'detail',
                        name: i18n.t('COMPANY_DETAIL.DETAIL')
                    },
                    // {
                    //     id: 2,
                    //     key: 'timeline',
                    //     name: i18n.t('COMPANY_DETAIL.TIMELINE')
                    // },
                    {
                        id: 3,
                        key: 'note',
                        name: i18n.t('COMPANY_DETAIL.NOTE')
                    },
                    // {
                    //     id: 4,
                    //     key: 'mail',
                    //     name: '電郵'
                    // },
                    // {
                    //     id: 4,
                    //     key: 'news',
                    //     name: '新聞'
                    // },
                    {
                        id: 5,
                        key: 'oppties',
                        name: i18n.t('COMPANY_DETAIL.ALL_OPPORTUNITIES'),
                    },
                    {
                        id: 6,
                        key: 'cases',
                        name: i18n.t('COMPANY_DETAIL.ALL_CASES'),
                    },
                    {
                        id: 7,
                        key: 'documents',
                        name: i18n.t('DOCUMENT.TITLE')
                    },
                    {
                        id: 8,
                        key: 'activities',
                        name: i18n.t('Bower_Title.Activity')
                    },
                ],
                wiAdvanceTabs:'',
                timeLineType: [{
                        id: 1,
                        key: 'all',
                        name: i18n.t('GENERAL.ALL'),
                    },
                    // {
                    //     id: 2,
                    //     key: 'mail',
                    //     name: '電郵'
                    // },
                    {
                        id: 3,
                        key: 'note',
                        name: i18n.t('COMPANY_DETAIL.NOTE')
                    },
                    {
                        id: 4,
                        key: 'FIELDHISTORY',
                        name: i18n.t('GENERAL.FIELDHISTORY')
                    },
                    {
                        id: 5,
                        key: 'activity',
                        name: i18n.t('Bower_Title.Activity')
                    }
                ],
                timeline_tab: ['all'],
                timelinetabData: {},
                breadcrumbs: [{
                        text: i18n.t('BREADCRUMBS.Companies'),
                        disabled: false,
                        href: '/Companies',
                    },
                    {
                        text: '',
                        disabled: true,
                        href: 'Account',
                    },
                ],
                contact: [{
                        name: 'Andy Wu',
                        nickName: 'AW',
                        job: 'CEO',
                        main: true,
                        pic: 'https://cdn.vuetifyjs.com/images/john.jpg',
                        phone: '0900-000-000',
                        email: 'key000@gmail.com',
                        company: '',
                    },
                    {
                        name: 'Kay Chen',
                        nickName: 'KC',
                        job: 'CEO',
                        main: true,
                        pic: '',
                        phone: '0900-000-000',
                        email: 'key000@gmail.com',
                        company: '',
                    },
                    {
                        name: 'Mia Lu',
                        nickName: 'ML',
                        job: 'CEO',
                        main: true,
                        pic: 'https://cdn.vuetifyjs.com/images/john.jpg',
                        phone: '0900-000-000',
                        email: 'key000@gmail.com',
                        company: '',
                    }
                ],
                newsPaper: [{
                        id: 1,
                        title: '我們真的需要超過 12.9 吋的 iPad 嗎？',
                        content: '蘋果產品預測準確率頗高的彭博社作者 Mark Gurman 最近發文，表示蘋果正在探索更大尺寸的 iPad，也就是說未來新 iPad 可能會超越現在 iPad Pro 的 12.9 吋。14 吋，又或是 16 吋？',
                        pic: 'styles/images/new1.png',
                        href: '#',
                    },
                    {
                        id: 2,
                        title: 'WFH 成永久趨勢？曼哈頓商辦空置率創史上新高',
                        content: '蘋果產品預測準確率頗高的彭博社作者 Mark Gurman 最近發文，表示蘋果正在探索更大尺寸的 iPad，也就是說未來新 iPad 可能會超越現在 iPad Pro 的 12.9 吋。14 吋，又或是 16 吋？',
                        pic: 'styles/images/new2.png',
                        href: '#',
                    }
                ],
                showDetailEditBtn: true,
                isDetailReadonly: true,
                own: 'James Campbell',
                people: [
                    { name: 'James Campbell', pic: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSR8zBnWt2f48y_tUcLks0aMS14C1da4qOBjw&usqp=CAU'},
                    { name: 'Sunny Chen', pic: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=707b9c33066bf8808c934c8ab394dff6'},
                    { name: 'Jason Lu', pic: 'https://cdn.vuetifyjs.com/images/john.jpg'},
                    { name: 'Mandy Wang', pic: 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoHCAkMEgoJCQoICAkICRkKCQkKCh8JCggNJSEnJyUhJCQpLj8zKSw4LSQkNEY0OC8xQ0M1GiQ7QDszPy40NTEBDAwMEA8QGRISGD8rIR0/MTQxMTYxMTQxMTcxPzQ0MUAxND0xMTE0MTQ0NDE0MTQxMTExMTExMTE0MTExMTExMf/AABEIAMgAyAMBIgACEQEDEQH/xAAbAAABBQEBAAAAAAAAAAAAAAADAAECBAUGB//EADkQAAICAQMCBAQEBAUEAwAAAAECAAMRBBIhBTETIkFRBjJhcRQjQoFSYqGxB3LR8PGRksHhFiQz/8QAGAEBAQEBAQAAAAAAAAAAAAAAAAECAwT/xAAiEQEBAAICAgICAwAAAAAAAAAAAQIRITEDQRJRE3EiYbH/2gAMAwEAAhEDEQA/AOkA5xC7YNzhof0kQyyLjEmokH9oCQQirIoIUCUDsWDQe8slMwezECSLE5CyHihZUuNjdu0bTSxvHqYltC8gZlZEY8EmWd1ajBZAfYtzIoq2huQpEW9uwkUesjuv7HMbemcbl55HMAmW9Y4TPMmEkwkAW2OgkmWREokcesjj2kbScgCEQHEAbQQXmWHUyOIAisbEKRI4MCIEUntPoIoFW1ckGHHaMy+0i+7sIBFIiYCDrB9ZY2esCK4ElvHpG2xAekgW8niM/vCIkd0PYQKTcnEoavq2npzXVtvcd3zipT95R611MbrKK22U0jF9oPzt7Tm7bLLQQuaKyfmPNjr/AOJLWscWjrevPyDdsHfZWkxreskZYC3JPc5g7mSseWt3ZRnzTLu1WoOSqIo+jZiNXhr6br9wOFsf6ZPaX9f1TUqik3upwNypySfvOT09zM43qGGefeb2uQAcDymtXAIyRkCaZS0nxb1DTlSuovdQea76/Eredt8P/F+i1pWnUBNHqXO1Mvmm1voT2nlb2DJA4P8AIcGDG0+ZSQfceXEJp746ekGE5nE/Bnxa7mvpnUX3s3k0mqc8uf4W/sDO4YxtNBOgOPcQqbRwYMn1kGMAzusCbF7xHmAJHMgd9SB6Qf4v7QVmD2lY8GBoDVH0EeVKm94oGmEHeIqJPHEbHvKAsOciEWM2Mxb1EB9pjbcHmO1oA4gHdjyIGggmX8R9SGjq8rKt2pPh1E/oHq37QqXv2OJw/wAZa1rNR+FLAiqlQ/0Xvj95LVk2zbLfEwx3mtTiist5nP8AEZLLdwQ5+UNjyg/SUV1C9xuJA2qPcmWeWADM5VjtVK/KX+g+n1ma6QHU7ASCxtx8xYZXMx9S9ZJIUMfRmbdidDZpa1Ph2IHuxgaevlKh9Y9XSGfkoiD6LuMz8pG/ha5vTg7gQCy55BnQalXYIy9npCjjGMTRq6HXkEgHHvNC3QV7UUD5BgHtL85pPx3bzzVq4JDLz9ZV3lTnJyp7+onU9W0AywAyD3WczqK2RsHkN8jd8zWOUrGWNgqWcgg7DnIwcYb3E9l+GOp/jtLRfYQ16DwdT7mwev7zxHd27Y9DjsZ33+GeuPjX6NuV1NPiAezr/wCjKzZw9CtYgZErbyTLd1RPAlZNO4PPaVlPdxKz98y54fvItUp9oFFlPpGFRPeXRUo7mS8g7wKqU4ih/HqHcrFBoQXEcGMWJgbSQcCSRjICKme8jqECjMIhOZHUozDiAJW4kSxELVWcc8QgpBgU1Jzn0nlfVdW1t2pubLNbexC+4HAnsY09YDZI+UzxDUg73yeUJx9zmSt4xZ0qA/mOSUQkYH6z6/6TW02/dlADqnGEUcrpVmYhWsYOAK8Vp6jfySf/AD+06v4a6cQgusU77hu/yLOWeWnfx47u6LoenKgGRuY8s7d3Mu7AsvNVgcSs6Gco7oKBIW9oQCRsX3lRka6tWBzw3vOT6ppRzxw/JH8De87O+sntzMPqml4Y7cccgzWN1WMsdxx6AeZXAz+o/WdB8Ear8PrdLY2BsJrce6kETFuTY27uM4YQ/TXNd1FgPNdwyf40zO0rz2Pb7eop3AJxKFvWawcAcysttDdsnPPaQxQTnY5Ofaacxm6sxOMYz2OI51Vp5Xd2g32cbKmYxK1/YUcfUQK9mq1bHA3f90YDUtyzGWQurzkUgj/LB3261flob/tgDFVvqTFBh+qNwKio940Dp7TX37wYsRfSDr34wVGZEpcxwFx+0bTSf4oE4UcxrNQ/bB5jJobs7juyYQ9OsbkkwoZewjIIWPW7d2sEs1dNzwxllem1r3gZT3nO0Mx9OBPJtTX/APYevnjVHcPfGf8ASe5V6CkHOATPJ/ifRijqOsrQEKh8QY9mwZnLpvHtjUAXXV0DlRYKzj+Inn+2J6gt+i0aIt1iI2MBFOWAnnHwtQLdQrHkJdvedB8SdQ0el/LOkR7GPlXGWczhectPVjNYt9ur6Gw7UuQn2Y4kLblPYjnsRPOL9dSX22dPt09mcba32uD9pr9K1RU7FttZc7RVaMNW0ZY65Mct8Os8QSvqdVWoJsdFA9ScSDpYq7iDyJzHW3RiDY1jBOPDQ43mTHmrldRf1HxBSD4dFb3P2GBGbVXWKfH0VqI4wLEO7H7TmTqdYj+Dp6k07btoUp5j+80+na/XNYdNaA7I2xypys63HU6cplLdbZvVKNhb0BOF+oi6XWWs0uBuzYEYY+s0/inTla1s/UWAaD+DlFmp0QbGDqQXjHmM58V7NV0bTKFOxScZMkvTqByK1/6S21xA/aBbUYGeZ1cCTS1Dsi/9InSteyjj6QC6ps9jI23s3ABgFVkPAC5kDWrdwsqpuByTD1K7HPGIBVpX0Cx4QKewMUADWVr6CKm2snnEpW7fWTTA5gaFtyDtAi+D7iDY4gWkuOeMwep1TLHrMHrlGMiBFNY/ecT8Z6f8/wDHgcX6XZYfTcs6rOJjfEdJvpZVOCpyP2kynDWPGUcv/h0ga28NjLVh1noOu6LpbVLmsG3HksAy9Z+k89+CSyamh9gRLLHoJnqvi8Y4PE8/HyevX8Y861/SbvE8azY9iEfmGva7sPUyx0roIew3WKzO53PYzcmdTqgrHJCkiE0D17vCUZdx6D0luVvFSYyc6C1+jRaACBuVe84mzp1dpJdFcq25c+89H6umamX5cL3nF1Oq2eG3r2PvLONJ2yX6MWIc5ZlG0NnkCXNJoK6BhUVZt7UxniUtT9MYi5VZhGB8UYNKLgkvZgf1kP8ADzRF9TTYeVrYsy4zyIbrKhxXWTyoLle5weJ0f+Heh8BNSbU2Ws4ADDDIntNYOfk4d5agxM61DNJmGMmULXB4E7POqiSzntDKgPeIIojSBomZbrGOIFV9ZPdCjBvQR4BSSYoGffWc5HoJNOcAwj5xjuYJcyA9h2jiV3Sw8jtCtk/WG/TnHpAhUrcCS1aEjAxmCWw+kjZa/r6QBJprG4IkNZ0wsqIO7uU/oZp6WwEZOMwF+qJZBjit9+ZKsrnf/jDqNNqOnMlOpuuTU2K5wCq43KPvNPV6goWHbBl7T2MpVQDmqwhTtzhDKHVKdzMR2bzicvLjqbenwZbtlY+p6gRnnmX+lU6lQ2qG1LnQitLOBgzLq0oFwewF608ypjOWl/VfFGk035dmk6g9irnAoKricZy73fpW6r1nWKBVqiiXBMPXUS6H7GYentvtKNaiVOmT5H3Ay3q/ifpLE3WU2JY67FSxtv8AeZ1XW+mN2fwTn9fInSS+2co2F1BA2k8iV7LC3EH4qOA9bB1YeVl5BjICxA5JzwJkjd6d0mhk03UbBc9v4xaEVOUC+5mz02hlZ7OxvdrWH0J4/sJCzSaqujQ00uiNTYLLVY7SXP8AyZpIFXdt4CkVr9hPTjOHjyu7VhuVx64lRgcwu/EZnzNMBvuUZglLt6ES6Bkc4xDrWuMgSCkiP25kvDbvLm0e0R/aUVVraKWgIoGSX9JECOEzJ+EfSQRhd424+kCyntDIgxAAOJFocp7QbVN6wJac4Bg35Of5uftDV1HtI+EQYDqOQw/UMGNqKt68fMvKwiofaT2nEmUlmq1jlcbuMJaitm4jsexh9UqOuHHKDyuO6TR1lK5DYwQMMR6yo4QjnBUzy2ar245b5cZ1Cos/mWq0KCENg7ZlOjptWfEsCOc5CKuEE6nVrp2OCq5+0zXrTOKxNTK6XLK1XK/wgACdB8M9KDk624A10Nius93s/wDUw2dV8q4d/U91Sdt8MIW0qnvvvcn69prCbvLj5MtY8C2ksdx9PkH1iXjC9/c/WWLK2znHbtBbCO4M7vOiUjlJIR8ys06ZPAlpDxiAp7EmN4ozjiQWsiDYwJsi8T1EGlhY0CHMaVdKG4iHrfIlVjC0sJEQubmPW57SbqCY6JCC04Y4MJftWDr4MjqHzgQplcCP4ikyuTGBJOBkn2HJgX0wZIpyB7mPpdLe3JQoo5JfjiFvXYfcYwHkyuo1jN1V1YBBmM42lhxhpq22DkTK1TAHM82T149MfWgqSQAw+szbLnbyjyj1C8TT1Z3ZxM5l9ZItQC4GZ2vwfqwarNOfmqs8QD+Qzi7W4wJb6Vrn01ld1fIUbLEPZ0nXG6u3LObmnpDOvrB5UnGJT0fUNPqAGqfnHmRhgoZcQc5nd5kbVVeT2gWas8DEPqhlZQrT3kFgOgGOJWfGcgx2QxCqAi69okeP4YEYKAYWJC4DgxSNu1eY0KHZp3HaRRGXvNd0zAeDznAhlSB95PcJa/Chsk4RV5dzwAIbGkqUWHbjG8WWDkyxFJK7W5WtiP4zwsPZokUbrHd2xkV1+X+8D+JRx4ldr35B2EnCweituZtSL94COBTuG1SmJqQWVq04AzWikjl7H3gQ+mqKk2eIHUcKldexEmbdSL9q73TLZ47GW2vTToAdzBAOB/SSzTU/pd091zFmtXYmfIhHIX6wFprtDipxYEbzhT5kaWKW3IXOV3LuAPcSnp0WkZQlstgntM6X/WXeCjbclg4yuRjmUtbW2Mj1m+morve5LKwg09mxbM7vEhygYFCunsrK8DGMzlfHvp1x8vx7jiGoY98ypfQVGTnAnaN02pN35bud3zeJ5QJU1PTKnGCtlag/eZ/Hk6flxriGGZZ0nT9TYFYJtrc8WM23K/SdVT0fSLnFCnjDWW+eWPDqTbtQOK1wpIwEE7YeP7cMvJ9KmnTwhtGEB8la/SF0Vusrdg9niVu2aye6D2Mgutqaw6dlZbUXf5hwRKr6nV1XKhTfprAF+TlG+87bjjqt/wDH1v8AlkoGx2D8yQx3GJlWaDTWFLiXrdB5XR9hEv1luFB3Z9TJrZvQxjgSqNRl7KiGU12bA5HFnaGDMBnhgO+D2kuNNns4gc5MVlp9AZAOJiukEdeIozvFAknUPRpbo1C2HavJIyfoJjOq8/ea/S9My1vZ8r3jhsZIWVhYW6ht1YKuUba6+gMqWrXql1FZJUofBYL3QEQZWjRqqWWqpBy72HaXYyHVN7afUWaVmS/YCHrGHfHMTpqznhV8FdMuwOzhOdzDB/3xJaLW16pPErV1VbNpFnv/ALMN4W5QLFzlfN98Qej0tenXwqt5RnNg3nJHb/San9M2/farXdeLzWGZK0UHBHDnHebC6dLQDZv4IY445EZURzgY3ZgNQuuSygVh1pzusZBlSPaSzXbUu+lrqd3gVOUzlUyPqe0B0x3tStrTuZxhzjHIlrUKjqa7FDqeDu9oNERFArATnaF77JNXv0u5rXsZ9JVWrNWCrWtvds9zMmjX+dtKy4KoLFb0x7QvSdXqLzf4rl0FmK1IxsXniNqtNX4htVStiAgMDjIiczgvF5R1fTrLzW9dr1cnISw15B+0M9goXDEhUG0sWySZFtalIpVwzb7NgKntG19LXpYid3RlUk+8cbuuznU30ELq70FlTF0YcMPvM/pF1xe6q9ncpYdofkoMy50rSX0IUuUISxYLuzjtLaPpmYhPDaxQC4UecD6yzd0l1NyKuo6dQzpeNyWKMK4PET6uqrC2ttBIVWPYmVer6rUU2VGtmWt7D4gAyrrxx/XMs36OvULhmZCDkMozyJZe5E11abqOne+thVkkqNoDY5lnpldiV1LaGDpXh9xyYqkNK7clwgCr/NJ9P1a3/oKg9vqI97T1wENVQ1j6c7xYjYOV4Ji1aJUGaraLXr2iwruIWXH0GmDtqCv5hOS2cAmYPX+otQKytZdXPhvg42iXd9pqWzTT6JrK9UmLVCaio+HanoWEuvpazzMLR2om26sKocixyON4nS7QwDKchhuU/SZsa2qfhh7xQ7p6AxTIxfnZKxgmxwgE06dXa2ou06YGm0dYR+O78Sr0ZA124gEVVlx9GOBNDqFtWlSy5UUbj4jlRy5Ml+2sfrXbI6/oLdS1bVlSqMTYrHtnE0NB+UFr83kAAz34wIDQ9RGoUsE2FDtde4mPrupaqiwCsjatYLq65NhPeXcnP21q3+P01/iF7KkssrLJtVdjL+jJ7wegseyqi18s71+Y+55mxaEsrrLojh0yyMM5HEoMir5UAFaHCqBgCbk52528a0lpFwXz6ngzTR+MZGRM6h88r68CWK1sDMxBClcDPtLUQ1TI3DhijNtBXjgw6V1DAXdtK9mkGZRgNjJOcERO5xkdsQmx0qrXPhoiE+Y7RjLTIu0upa3chRqCnnXfglveXdBnBY7id2eTnmPYc7iMZwcY95NL8tKF+h8QLklWR9y8Z7w+GQbirtjyhQO8ibLF5XLc859ZaRmIwCMkd8S6m9p8qr1s96EiuyoOCuLE2nMz06dqEvs1AC7LB5jvwQf9jM3FezGHcNj+XEq2XjcEIbLDg+kmt9rMrOkLq9wwwQk+h9RBPTYFIodEbadrsMjMlqUduQW7g8H0h0xgA9sc5mtJtHTVNtVbrEewjztWu1XMLptHRV/+e5cngFuBFUiD5FUHGeO0G4sUhl3E7hkY4IkpKzuu13s+lNZdQNSA20+nH9JT19FGpayk2ZCWbGCNyGH/ADNjUuSec+UZ49phdN0FiG+21kNmqvNjBT8oMknP7XfH6B6vTsoXwd4ahlsQA8lQROq6VbuprJPKjbOOOovXWWaZz4lVtW9Af0ETf6ffgOiNu2t6HPMU5mmyzLnnEeZ+4sclsCPMKq6ah/DtClkfU2rSrqcEAcmaerpruTwbNzgjbnODiKKJ2s6jOTT16dRWhCAZPu33hNtT4NgRwpxWcZKGKKakiW3YfUq2vpRNPY6WVXhq3B/UORn7y63OT3BHIjRS490yNp02n6A5JlxbkYlVYEr8wjxS1mKuqRmIyGwXzuHeWBx82CPU/WNFCjB1xYV2khcAg+szyx3qBkDGPpFFICKoHMXbkdy2B7Ax4pplJC5GW27T2I9pFU5zwwx2PeKKRaG7qmc9sf0iU7h5fMGAP3EUUqG0yWKzAh9pOQT7yzqNTXXjxCVHAJiikGTqr+5TzGz8tf8ALnmYnVOuDStWgqNqOCXcHBCj2jxSZ2zpvCS9rtA077NUETxGTiwjzbDzB9EqdLNajAiuzU+JST2KkA/3iilvSe62NQuBxxFFFOY//9k='},
                ],
                addressee: [],
                copy: [],
                // oppties data table
                page: 1,
                pageCount: 0,
                searchDeals: '',
                itemPerPage: 12,
                dealsHeaders: [
                    {
                        text: i18n.t('COMPANY_DETAIL.DEAL'),
                        value: 'name',
                        width: '20%',
                        align: 'center'
                    },
                    {
                        text: i18n.t('TO_CASE.STATUS'),
                        value: 'closed_reason',
                        align: 'center',
                    },
                    {
                        text: i18n.t('COMPANY_DETAIL.STAGE'),
                        value: 'current_stage.sequence_number',
                        width: '15%',
                        align: 'center'
                    },
                    {
                        text: i18n.t('TO_DEAL.AMOUNT'),
                        value: 'amount',
                        width: '15%',
                        align: 'right',
                    },
                    {
                        text: i18n.t('TO_DEAL.EXPECTED_CLOSE_DATE'),
                        value: 'expected_close_date',
                        width: '18%',
                        align: 'center'
                    },
                    {
                        text: i18n.t('GENERAL.ACTIVE'),
                        value: 'active',
                        align: 'center',
                        sortable: false,
                    },
                ],
                // Dialog
                addDealDialog: false,
                toDealDialog: false,
                changeOwnDialog: false,
                editAccountDialog: false,
                edtorAccountData: '',
                mainContactsDialog: false,
                addContactDialog: false,
                activityDialog: false,
                messageDialog: false,
                message: '',
                successDialog: false,
                errorDialog: false,
                addNoteDialog: false,
                editNoteDialog: false,
                errorMessage: '',
                showDealsMore: false,
                choseEmailTemplate: '',
                emailTemplateData: [
                    {
                        idx: 1,
                        templateName: 'template 1',
                        createTime: '2021/10/20',
                        lastModifyTime: '2021/10/20',
                        templateContent: 'Hi Everyone. {{contact.owner}} {{deal.title}}',
                        contactTemplateVal: ['{{contact.owner}}'],
                        dealTemplateVal: ['{{contact.owner}}'],
                    }
                ],
                emailTemplateTabs:'',
                emailTemplateContactValList: [],
                insertContactVal: '',
                emailTemplateDealValList: [],
                insertDealVal: '',
                contactTemplateVal: '',
                mainContactData: {},
                noteData: {},
                isNoteTab: false,
                OriginalTimeLines: [],
                originOrgData: {},
                delMode: '',
                succMode: '',
                noteIdOnDelete: null,
                onClickNote: {},
                opptyData: null,
                showNoteMore: false,
                formRule: {
                    nameRules: [
                        (v) => !!v || i18n.t('RULE.RULE_R_COMPANY_NAME'),
                        (v) => /^.{0,200}$/.test(v) || i18n.t('RULE.RULE_200')
                    ],
                    urlRules: [
                        (v) => /^(http(s):\/\/.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$|(^$)|null/.test(v) || i18n.t('RULE.RULE_URL'),
                        (v) => /^.{0,200}$/.test(v) || i18n.t('RULE.RULE_200')
                    ],
                    intRules: [
                        (v) => /^[0-9\s]*$|(^$)|null/.test(v) || i18n.t('RULE.RULE_NUM'),
                        (v) => /^.{0,9}$/.test(v) || i18n.t('RULE.RULE_9')
                        ],
                    BigIntRules: [
                        (v) => /^[0-9\s]*$|(^$)|null/.test(v) || i18n.t('RULE.RULE_NUM'),
                        (v) => /^.{0,16}$/.test(v) || i18n.t('RULE.RULE_16')
                        ],
                    emailRules: [
                        (v) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$|(^$)|null/.test(v) || i18n.t('RULE.RULE_EMAIL'),
                        (v) => /^.{0,50}$/.test(v) || i18n.t('RULE.RULE_50')
                    ],
                    contentLenRule70: [(v) => /^.{0,70}$/.test(v) || i18n.t('RULE.RULE_70')],
                    contentLenRule50: [(v) => /^.{0,50}$/.test(v) || i18n.t('RULE.RULE_50')],
                    contentLenRule20: [(v) => /^.{0,20}$/.test(v) || i18n.t('RULE.RULE_20')],
                    contentLenRule10: [(v) => /^.{0,10}$/.test(v) || i18n.t('RULE.RULE_10')],
                    contentLenRule100: [
                        (v) => /^.{0,100}$/.test(v) || i18n.t('RULE.RULE_100'),
                    ],
                    contentLenRule100X: [
                        (v) => /^.{0,100}$/.test(v) || i18n.t('RULE.RULE_100'),
                        (v) => !!v || i18n.t('RULE.RULE_R'),
                    ],
                    selectRuleX: [
                        (v) => !!v || i18n.t('RULE.RULE_R'),
                    ],
                },
                belongGroupList:belongGroupList,
                wiadvancePaymentTermList: wiadvancePaymentTermList,
                paymentTermsList: paymentTermsList,
                isPhoto: false,    
                haveOppty:false,
                moreOppty:false,
                havetimeLines:false,
                industryName:'',
                typeName: '',
                haveContact:false,
                accountContacts: {},
                accountContactsAmount: 0,
                addDealData: {},
                delDealData: {},
                btnText: 'MORE',
                alertNote: [],
                pinning: true,
                getfolder: true,
                annualRevenueShow:false,
                formatAR:null,
                aRValidate:true,
                registeredCapitalShow:false,
                formatRC:null,
                rCValidate:true,
                openOppties: [],
                openCasesCount: 0,
                openCases: [],
                addCaseDialog: false,
                addCaseData: {},
                target_id: this.$route.params.id !=undefined ? this.$route.params.id : sessionStorage.getItem('page_id'),
                //document
                isdocumentTab:false,
                isDelDocument:false,
                openDelDocumentDialog:false,
                isAddDoucment:false,
                haveOpptyList:false,
                // activity
                activity_mode:"list",
                isActivityTab:false,
                isAddActivity:false,
                activityTimeline:[],
                originTimeLines:[],
                due_activity_list:[],
                full_name: "",
                user_list:[],
                isFollow:false,
                timeline_count:0,
                timeline_show_count:0,
                timeline_max_height:'',
                // end_customer - For INDUSTRY IT ONLY
                pref_industry:'',
                isEndCustomerTab:false,
                end_customer_type:'',
                end_customer_type_tabs: [],
                isAddEndCustomer:false,
                dateList: Array.from({ length: 31  }, (_, index)=>({
                    key: (index + 1).toString(),
                    name: i18n.t(`THEDAYOFEVERYMONTH.${index + 1}`)
                })),
                isTechUser: false,
                is_staff: false,
                cFEditable: true,
            }
        },
        async created(){
            this.loading = true;
            await (this.uuidCheck(this.target_id))
            await OrganizationDataService.getOrgDetail(this.target_id)
            .then(response => {
                this.orgDetail = response.data;
                this.orgDetail.closing_date = this.orgDetail.closing_date == null ? [] : this.orgDetail.closing_date.split(',');
                this.orgDetail.regular_payment_date = this.orgDetail.regular_payment_date == null ? [] : this.orgDetail.regular_payment_date.split(',');
                this.isFollow = this.orgDetail.follow;
                const title = localStorage.getItem('title');
                document.title = title+' : '+this.orgDetail.name +' – UpDay';
                this.check = [this.orgDetail.employee,this.orgDetail.annual_revenue,this.orgDetail.registered_capital];
                this.changeOwnData = this.orgDetail.owner;
                this.userphoto = response.data.owner.usersetting.photo;
                this.orgImageNow = response.data.image; 
                this.getBreadCrumb();
                this.industryName = this.getIndustryName();
                this.typeName = this.getItemNameFromList(this.orgtypeList, this.orgDetail.organization_type);
                this.openOppties = this.orgDetail.opportunity_set.filter(item => item.closed_reason < 1 || item.closed_reason == null || item.closed_reason == undefined || item.closed_reason == " ");
                if(this.orgDetail.annual_revenue >0){
                    this.formatAR = this.getFormatAmount(this.orgDetail.annual_revenue).slice(0,-3);
                    // this.orgDetail.annual_revenue = this.orgDetail.annual_revenue;
                }else if (this.orgDetail.annual_revenue == 0)
                {
                    this.formatAR = 0;
                }
                if(this.orgDetail.registered_capital>0){
                    this.formatRC = this.getFormatAmount(this.orgDetail.registered_capital).slice(0,-3);
                    // this.orgDetail.registered_capital = this.orgDetail.registered_capital;
                }else if (this.orgDetail.registered_capital == 0)
                {
                    this.formatRC = 0;
                }
                if(response.data.custom_field != null){
                this.customFieldData =  response.data.custom_field;
                }
                if(this.userphoto!=null){
                    this.isPhoto = true;
                }
                if(this.openOppties.length > 0)
                {
                    this.haveOppty = true;
                }    
                if(this.orgDetail.contacts.length > 0)
                {
                    this.haveContact = true;
                    this.accountContactsAmount = this.orgDetail.contacts.length;
                    this.accountContacts = this.orgDetail.contacts;
                    this.accountContacts = this.sortContactsJson(this.accountContacts,"first_name");
                } else {
                    this.haveContact = false;
                    this.accountContactsAmount = this.orgDetail.contacts.length;
                    this.accountContacts = this.orgDetail.contacts;
                    this.accountContacts = this.sortContactsJson(this.accountContacts,"first_name");
                }
                if(this.orgDetail.opportunity_set.length>0){
                    this.haveOpptyList = true;
                }

            })
            .catch(response => {
                // Redirect to PermissionError page if error status is 403
                if (response.response.status == 403)
                {
                    this.$router.replace('/PermissionError');
                }
                else if(response.response.status == 404)
                {
                    this.$router.replace('/PageNotFound');
                }
            });
            if(this.isWiadvance()){
                this.customer_code_List = await getCustomerCodeListOptions(this.orgDetail.name);
            }
            await this.getOrgTimeLine();
            await this.getActivityTimeline();
            const caseSearch = {"org":this.target_id}
            await CaseDataService.detailcard(caseSearch).then((response)=>{                
                this.openCases = response.data;
                this.openCases.forEach(caseItem => {
                    if (caseItem.closed_reason == null) {
                        this.openCasesCount ++;
                    }
                });
            });

            await CampaignDataService.selectlist().then((response)=>{
                this.campaignList = response.data;
            })
            await PersonalSettingService.getCurrentUserDetail()
            .then(response => {
                if(response.data[0]['usersetting']['timeline_tab'] != null){
                    if(response.data[0]['usersetting']['timeline_tab']['Organization'] != undefined){
                        this.timeline_tab = response.data[0]['usersetting']['timeline_tab']['Organization'];
                    }
                    else{
                        this.timeline_tab = ['all'];
                    }
                }
                else{
                    this.timeline_tab = ['all'];
                }
            })
            .catch(response => {
                this.showErrorDialog(response);
            });
            await this.showTimlinesCheck();
            await PreferenceService.getINDUSTRY().then((response)=>{                
                this.pref_industry = response.data;
                if (this.pref_industry=="IT"){
                    this.tabs.push({
                        id: 9,
                        key: 'end_customer',
                        name: i18n.t('END_CUSTOMER.TITLE')
                    });
                }
            });
            await PreferenceService.getCUSTOM_DATA().then((response)=>{
                if (response.data == ''){
                    this.end_customer_type_tabs = [];
                }else{
                    this.end_customer_type_tabs = response.data.end_customer_data;
                }
            });
            await (this.loading = false);
            window.addEventListener('resize', this.onResize)
            this.onResize();
            const io = new IntersectionObserver((mutations) => {
                const isTimelineBtm = mutations[0].isIntersecting;
                if(isTimelineBtm && this.timeline_show_count > this.timeline_count){
                    this.timeline_count = this.timeline_count + 100;
                }
            });
            io.observe(document.getElementById('timeline_btm'));
            this.checkTechUser();
            this.wiadvanceHideCaseTab();
        },
        updated() {
            let n = 0
            this.openCases.forEach(caseItem => {
                if (caseItem.closed_reason == null) {
                    n ++;
                }
            });
            this.openCasesCount = n;
        },
        destroyed() {
            window.removeEventListener('resize', this.onResize)
        },
        methods: {
            checkMore(content,length){
                if(content.replace( /(<([^>]+)>)/ig, '').length > length || content.includes('base64')){
                    return true;
                }else{
                    return false;
                }
            },
            onEmitChangeFollow(val){
                this.orgDetail.follow = val;
                this.isFollow  = val;
            },
            async getOrgTimeLine(){
                await OrganizationDataService.getOrgTimeline(this.target_id)
                .then(response => {
                    this.timeLines = this.arrangeTimeLine(response.data);
                    let i = 0;
                    this.alertNote = [];
                    this.timeLines.forEach(item => {
                        // item.timeConvert = this.getFormatTime(new Date(item.time+"Z"))
                        item.timeConvert = this.getFormatTime(new Date(item.time))
                        if(item.type == "NOTE" && item.pinned ==true){
                        item.alertTime = this.getLittleFormatTime(new Date(item.time))
                        this.alertNote.push(item)
                        }
                        if (item.type == "NOTE") {
                            if (item.content.length > 300) {
                                this.$set(this.timeLines[i], 'isMore_timeLineAll', true);
                                this.$set(this.timeLines[i], 'isMore_timeLineNote', true);
                                this.$set(this.timeLines[i], 'isMore_note', true);
                            } else {
                                this.$set(this.timeLines[i], 'isMore_timeLineAll', false);
                                this.$set(this.timeLines[i], 'isMore_timeLineNote', false);
                                this.$set(this.timeLines[i], 'isMore_note', false);
                            }
                        }
                        i ++;
                    });
                    this.originTimeLines = JSON.parse(JSON.stringify(this.timeLines));
                })
                .catch(response => {
                    this.showErrorDialog(response);
                });
            },
            validateForm(){
                if(this.$refs.form.validate())
                    return true;
                else
                    return false;
            },
            sortContactsJson(json,key){
                for(let k=1, jl=json.length; k < jl; k++){
                    let temp = json[k],
                        i = k-1;
                    while(i >=0 && !json[i]['organizationcontacts_set'][0]['main_contact']){
                        json[i+1] = json[i];
                        i = i-1;    
                    }
                    json[i+1] = temp;                
                }
                for(let k=1, jl=json.length; k < jl; k++){
                    let temp = json[k],
                        value = temp[key],
                        ismain_contact = temp['organizationcontacts_set'][0]['main_contact'],
                        i = k-1;
                    while(i >=0 && ((json[i]['organizationcontacts_set'][0]['main_contact'] && ismain_contact && json[i][key]>value)
                                 || (!json[i]['organizationcontacts_set'][0]['main_contact'] && !ismain_contact && json[i][key]>value))){
                        json[i+1] = json[i];
                        i = i-1;    
                    }
                    json[i+1] = temp;                
                }
                return json;
            },
            changeSelectedColor(key){
                if(this.timeline_tab.includes(key)){
                    return 'v-tab tabBtn-selected';
                }
                else{
                    return 'v-tab tabBtn-unselect';
                }
            },
            onChangeTltSelected(){
                let choosedbtn = document.getElementById(event.target.id);
                let choosedbtnkey = choosedbtn.getAttribute('id').substring(4);
                if(choosedbtnkey == 'all'){
                    this.timeline_tab = ['all'];
                }
                else{
                    if(this.timeline_tab.includes('all')){
                        this.timeline_tab.pop();
                        this.timeline_tab.push(choosedbtnkey);
                    }
                    else if(this.timeline_tab.includes(choosedbtnkey)){
                        let index = this.timeline_tab.indexOf(choosedbtnkey);
                        this.timeline_tab.splice(index,1);
                        if(this.timeline_tab.length == 0)
                            this.timeline_tab = ['all'];
                    }
                    else{
                        this.timeline_tab.push(choosedbtnkey);
                        if(this.timeline_tab.length == (this.timeLineType.length-1)) 
                            this.timeline_tab = ['all'];
                    }
                }
                let user = JSON.parse(window.localStorage.getItem('user'));
                let userid = user['userid'];
                this.timelinetabData['user_id'] = userid;
                this.timelinetabData['Organization'] = this.timeline_tab;
                PersonalSettingService.updateUserTimelineTab(userid,this.timelinetabData)
                .catch(response => {
                    this.showErrorDialog(response);
                })
                this.showTimlinesCheck();          
            },
            showTimlinesCheck(){
                this.showTimelines = this.timeLines;
                for(let i = 0,ll = this.showTimelines.length ; i<ll ; i++){
                    // 預設show全部false
                    this.showTimelines[i]['show'] = false;
                    // 到期活動 & 釘選改為 true
                    if(this.showTimelines[i]['type'] == 'DUE_ACTIVITY')
                        this.showTimelines[i]['show'] = true;
                    if(this.showTimelines[i]['pinned'] !== undefined && this.showTimelines[i]['pinned'] == true)
                        this.showTimelines[i]['show'] = true;
                    // 當篩選為all 改為 全true
                    if(this.timeline_tab.includes('all'))
                        this.showTimelines[i]['show'] = true;
                    // 依篩選調整顯示項目
                    if(this.timeline_tab.includes('note')){
                        if(this.showTimelines[i]['type'] == 'NOTE')
                            this.showTimelines[i]['show'] = true;
                    }
                    if(this.timeline_tab.includes('FIELDHISTORY')){
                        if(this.showTimelines[i]['type'] == 'FIELDHISTORY')
                            this.showTimelines[i]['show'] = true;
                    }
                    if(this.timeline_tab.includes('activity')){
                        if(this.showTimelines[i]['type'] == 'ACTIVITY_FIELDHISTORY')
                            this.showTimelines[i]['show'] = true;
                    }
                }
                let showList = this.showTimelines.filter(el => el.show == true);
                for (let i in showList){
                    showList[i]['show_index'] = parseInt(i);
                }
                this.timeline_show_count = showList.length;
                this.timeline_count = 100;
            },
            getBreadCrumb() {
                this.breadcrumbs[1].text = this.orgDetail.name;
            },
            // About Company Logo
            changephoto(){
                this.$refs.uploader.$refs.input.click()
            },
            uploadimage(event){
                if (event != null) {
                    // file type
                    let n = event.type.indexOf("image");
                    if (n == -1) {
                        this.showErrorDialog(i18n.t('COMPANY_DETAIL.ERROR'));
                    } else {
                    // photo size
                        if (event.size > 5242880) {
                            this.showErrorDialog(i18n.t('COMPANY_DETAIL.ERROR_2'));
                        } else {
                            OrganizationDataService.image(this.orgDetail.id, this.orgImage)
                            .then(response => {
                                this.orgDetail.image = response.data.image;              
                            })
                        }
                    }
                }
                
            },
            // End Company Logo
            // About TimeLine
            getTimeLineIcon: function(type){
                let icon = "";
                switch (type) {
                    case "EMAIL":
                        icon = 'icon-mail';
                        break;
                    case "NOTE":
                        icon = 'icon-note';
                        break;
                    case "FIELDHISTORY":
                        icon = 'mdi-history';
                        break;
                    default:
                        icon = 'mdi-help-circle';
                        break;
                    case "ACTIVITY_FIELDHISTORY":
                        icon = 'icon-calendar';
                        break;
                    case "DUE_ACTIVITY":
                        icon = 'mdi-bell-ring';
                        break;
                }
                return icon;
            },
            // End TimeLine
            onResize: function () {
                let windowH = window.innerHeight - 420; //table高度
                let objH = 48;
                this.itemPerPage = parseInt(windowH/objH);
                setTimeout(()=>{
                    let timelineHeight = document.getElementsByClassName('v-window__container')[0].offsetHeight;
                    this.timeline_max_height = `max-height:${timelineHeight-140}px;`
                },100);
            },
            onCall: function (cell) {
                return 'tel:'+cell;
            },
            onMail: function (mail) {
                return 'mailto:'+mail;
            },
            // About Deal
            getStatusColor: function (eventStatus) {
                let color = '';
                switch (eventStatus) {
                    case 1:
                        color = 'green';
                        break;
                    case 2:
                        color = 'red';
                        break;
                    case 3:
                        color = 'gary';
                        break;
                    case 4:
                        color = 'orange';
                        break;
                    default:
                        color = 'gary';
                        break;
                }
                return color;
            },
            getIndex(array, obj) {
                let index = array.findIndex(item => {
                    return item.id === obj.id
                });
                return index;
            },
            onEditDetail: function() {
                this.originOrgData = JSON.parse(JSON.stringify(this.orgDetail))
                this.showDetailEditBtn = false;
                this.isDetailReadonly = false;
            },
            cancelEditDetail: function() {
                this.orgDetail = this.originOrgData;
                this.orgDetail.temp_owner = 0;
                this.showDetailEditBtn = true;
                this.isDetailReadonly = true;
                if(this.orgDetail.annual_revenue>0)
                    {this.formatAR = this.getFormatAmount(this.orgDetail.annual_revenue).slice(0,-3);}
                else
                    {this.formatAR = 0}
                if(this.orgDetail.registered_capital>0 )
                    {this.formatRC = this.getFormatAmount(this.orgDetail.registered_capital).slice(0,-3);}
                else
                    {this.formatRC = 0}
                this.aRValidate = true;
                this.rCValidate = true;
            },
            async confirmEditDetail(){
                if(this.validateForm()){
                    await (this.loading_orgDeatil = true);            
                    if(this.orgDetail.annual_revenue=="" | this.orgDetail.annual_revenue==0){						
                        this.orgDetail.annual_revenue = 0
                    }
                    if(this.orgDetail.registered_capital=="" | this.orgDetail.registered_capital==0){						
                        this.orgDetail.registered_capital = 0
                    }
                    this.orgDetail.closing_date = (this.orgDetail.closing_date == '' || this.orgDetail.closing_date == null) ? null : this.orgDetail.closing_date.join(',');
                    this.orgDetail.regular_payment_date = (this.orgDetail.regular_payment_date == '' || this.orgDetail.regular_payment_date == null) ? null : this.orgDetail.regular_payment_date.join(',');
                    // In wiadvance check customer code
                    if(this.isWiadvance() && await checkCustomerCodeRepeat(this.orgDetail.id, this.orgDetail)){
                        this.showErrorDialog(i18n.t('COMPANY.WIADVANCE_REPEAT_CUSTOMERCODE'));
                        this.loading_orgDeatil = false;
                    }else{              
                        await OrganizationDataService.edit(this.orgDetail)
                        .then((response) => {
                            this.showDetailEditBtn = true;
                            this.isDetailReadonly = true;
                            this.orgDetail.temp_owner = 0;
                            this.orgDetail.owner = response.data.owner;
                            this.userphoto = response.data.owner.usersetting.photo
                            if(this.userphoto!=null){
                                this.isPhoto = true;
                            }else{
                                this.isPhoto = false;
                            }
                            this.changeOwnData = this.orgDetail.owner;
                            this.orgDetail.image = this.orgImageNow;
                            this.typeName = this.getItemNameFromList(this.orgtypeList, this.orgDetail.organization_type);
                            this.orgDetail.closing_date = this.orgDetail.closing_date == null ? [] : this.orgDetail.closing_date.split(',');
                            this.orgDetail.regular_payment_date = this.orgDetail.regular_payment_date == null ? [] : this.orgDetail.regular_payment_date.split(',');
                            if(this.orgDetail.annual_revenue!=null){						
                                // this.orgDetail.annual_revenue = this.orgDetail.annual_revenue
                            }
                            if(this.orgDetail.registered_capital!=null){						
                                // this.orgDetail.registered_capital = this.orgDetail.registered_capital
                            }
                            // this.dataCheck = [this.orgDetail.employee,this.orgDetail.annual_revenue,this.orgDetail.registered_capital];
                            // if(this.check[0] != this.dataCheck[0])
                            //     {
                            //         this.changeText = i18n.t('COMPANY_DETAIL.TIMELINE_EMPLOYEE') + this.orgDetail.employee + i18n.t('COMPANY_DETAIL.TIMELINE_PEOPLE')
                            //         this.getFieldHistoryData(this.changeText);                            
                            //         this.timeLines.unshift(this.fieldhistoryData);
                            //         this.check[0] = this.dataCheck[0];
                            //     }
                            // if (this.check[1] != this.dataCheck[1])
                            //     {
                            //         this.changeText = i18n.t('COMPANY_DETAIL.TIMELINE_REVENUE') + this.orgDetail.annual_revenue
                            //         this.getFieldHistoryData(this.changeText)
                            //         this.timeLines.unshift(this.fieldhistoryData);
                            //         this.check[1] = this.dataCheck[1];
                            //     } 
                            // if(this.check[2] != this.dataCheck[2])
                            //     {      
                            //         this.changeText = i18n.t('COMPANY_DETAIL.TIMELINE_CAPITAL') + this.orgDetail.registered_capital
                            //         this.getFieldHistoryData(this.changeText)
                            //         this.timeLines.unshift(this.fieldhistoryData);
                            //         this.check[2] = this.dataCheck[2];
                            //     }
                            this.refreshTimeLine();
                            this.industryName = this.getIndustryName()
                        })
                        .catch(response =>{
                            this.showErrorDialog(response);
                        })
                        await (this.loading_orgDeatil = false);
                    } 
                }
            },
            // Dialog
            async onChangeOwn(data) {
                await (this.otherData.org_id = data.id);
                await (this.otherData.name = data.name);
                await (this.changeOwnDialog = true);
            },
            onEmitChangeOwnDialog(val) {
                this.changeOwnDialog = false;
                if (val) {
                    this.succMode = "changeOwn";
                    this.showSuccessDialog();
                }
            },
            onMainContacts(data) {                
                this.mainContactsDialog = true;
                this.mainContactData = data;
                this.mainContactData.forEach(item => {
                    item.job = item.organizationcontacts_set[0].position;
                });
                this.mainContactData.orgId = this.orgDetail.id;
                
            },
            onEmitMainContactsDialog() {
                this.mainContactsDialog = false;
                this.getOrgDetailAll();
            },
            getOrgDetailAll() {                
                OrganizationDataService.getOrgDetail(this.target_id)
                .then(response => {
                    this.orgDetail = response.data;
                    this.accountContacts = this.orgDetail.contacts
                    this.accountContacts = this.sortContactsJson(this.accountContacts,"first_name")
                    this.mainContactData = this.accountContacts;
                    this.mainContactData.forEach(item => {
                        item.job = item.organizationcontacts_set[0].position;
                        if(!item.full_name)
                        {
                            if(item.first_name != null)
                                item.full_name = item.last_name +" "+ item.first_name;
                            else
                                item.full_name = item.last_name;
                        }
                    });
                    this.mainContactData.orgId = this.orgDetail.id;

                    if(this.orgDetail.contacts.length > 0){
                        this.haveContact = true;
                    }
                    else{
                        this.haveContact = false;
                    }
                    this.accountContactsAmount = this.orgDetail.contacts.length;
                })
                .catch(response => {
                    this.showErrorDialog(response);
                })
            },
            auto_complete_by_bc_data(){
                if(this.customer_code_List != [] && this.orgDetail.customer_code != null){
                    let option_obj = this.customer_code_List.find(item => item.key == this.orgDetail.customer_code)
                    let bc_data = option_obj.bc_data;
                    this.orgDetail.company_number = bc_data.taxRegistrationNumber;
                    this.orgDetail.name = bc_data.displayName ;
                    this.orgDetail.english_department = bc_data.englishName ;
                    this.orgDetail.country = bc_data.country;
                    this.orgDetail.zip_code = bc_data.postalCode;
                    this.orgDetail.city = bc_data.city;
                    this.orgDetail.billing_address = bc_data.addressLine1;
                    this.orgDetail.sub_address = bc_data.addressLine2;
                    this.orgDetail.belong_group = bc_data.belong_group;
                    this.orgDetail.payment_term = bc_data.payment_term;
                    this.orgDetail.closing_date = bc_data.closing_date == "" ? [] : bc_data.closing_date.split(',');
                    this.orgDetail.regular_payment_date = bc_data.regular_payment_date == "" ? [] : bc_data.regular_payment_date.split(',');
                    this.orgDetail.temp_owner = bc_data.owner;
                }
            },
            onEmitMainContactMessage(text) {
                if (text == 'success') {
                    this.getOrgDetailAll();
                }
            },
            onEditAactivity() {
                this.activityDialog = true;
            },
            onEmitActivityDialog(val) {
                this.activityDialog = false;
                if (val) {
                    this.showSuccessDialog();
                }
            },
            showSuccessDialog() {
                this.successDialog = true;                
            },
            async onEmitSuccessDialog() {
                this.successDialog = false;
                if (this.succMode == 'changeOwn') {
                    this.changeText = i18n.t('COMPANY_DETAIL.TIMELINE_OWNER')+`${this.changeOwnData.last_name} ${this.changeOwnData.first_name}`
                    await this.refreshTimeLine();
                    // this.$router.push('/Companies');
                }
                if(this.del)
                {
                    this.$router.replace('/Companies');                      
                }
                this.succMode = '';
            },
            showMessageDialog(message) {
                this.messageDialog = true;
                this.message = message;
            },
            showErrorDialog(message) {
                this.errorDialog = true;
                this.errorMessage = message;
            },
            onEmitErrorDialog() {
                this.errorDialog = false;
            },
            async onDelete(){
                this.showMessageDialog(i18n.t('COMPANY_DETAIL.MESSAGE_3'));                
                this.delMode = 'delOrg' 
            },
            onDeleteDeal(item){
                this.delDealData = item;
                this.delMode = 'delDeal';
                this.showMessageDialog(i18n.t('COMPANY_DETAIL.MESSAGE_2'));
            },
            async onEmitMessageDialog(val) {
                this.messageDialog = false;
                if (val && this.delMode == 'delOrg') {
                    await OrganizationDataService.delete(this.orgDetail.id)
                    .then((response)=>{
                        if(response.data.error === 'Have Opportunity!'){
                            this.showErrorDialog(i18n.t('COMPANY.MESSAGE_3'));
                        }
                        else{
                            this.showSuccessDialog();
                            this.$router.replace('/Companies');
                        }
                    })
                    .catch((response) => {
                        this.showErrorDialog(response)
                    });
                }
                if (val && this.delMode == 'delNote'){
                    await NoteDataService.deleteNote(this.noteIdOnDelete)
                    .then(() => {
                        this.deleteNoteFrontEnd(this.noteIdOnDelete);
                        this.showSuccessDialog();
                    })
                    .catch(response => {
                        this.showErrorDialog(response);
                    });
                    this.noteIdOnDelete == null;
                }
                if (val && this.delMode == 'delDeal'){
                    this.messageDialog = false;
                     
                    await OpportunityDataService.delete(this.delDealData.id)
                    .then(() => {
                        let deleteIndex_allOppty = this.getIndex(this.orgDetail.opportunity_set, this.delDealData);
                        this.orgDetail.opportunity_set.splice(deleteIndex_allOppty, 1);

                        if(this.delDealData.closed_reason < 1 || this.delDealData.closed_reason == null || this.delDealData.closed_reason == undefined || this.delDealData.closed_reason == " "){
                            let deleteIndex_openOppty = this.getIndex(this.openOppties, this.delDealData)
                            this.openOppties.splice(deleteIndex_openOppty, 1);
                        }
                    })
                    this.successDialog = true; 
                    this.delDealData = {};
                }
                
                this.delMode = '';
            },
            showEditAccount() {
                this.editAccountDialog = true;
            },
            onEmitEditAccountDialog(val) {
                this.editAccountDialog = false;
                if (val) {
                    this.showSuccessDialog();
                }
            },
            showAddDealDialog() {
                this.addDealData = {
                    name: null,
                    primary_contact: null,
                    oppty_org: {
                        id: this.orgDetail.id,
                        name: this.orgDetail.name,
                        company_number: this.orgDetail.company_number,
                        customer_code: this.orgDetail.customer_code
                    },
                    stage_type: null,
                    amount: null,
                    expected_close_date: null,
                    forecast_category: 1,
                }
                this.addDealDialog = true;
            },
            onEmitAddDealDialog(val) {
                this.addDealDialog = false;
                if (val) {
                    this.showSuccessDialog();
                }
            },
            onEmitNewDealData(data) {
                if (data.oppty_org != null) {
                    if (this.orgDetail.id == data.oppty_org.id) {
                        this.openOppties.unshift(data);
                        this.orgDetail.opportunity_set.unshift(data);
                        this.haveOppty = true;
                    }
                }
            },
            showAddCaseDialog(){
                this.addCaseData = {
                    subject: '',
                    primary_contact: null,
                    case_org: {
                        id: this.orgDetail.id,
                        name: this.orgDetail.name,
                        company_number: this.orgDetail.company_number,
                    },
                    source: '',
                    group: '',
                    type: '',
                    due_date: '',
                };
                this.addCaseDialog = true;
            },
            onEmitAddCaseDialog(val){
                this.addCaseDialog = false;
                if(val){
                    this.showSuccessDialog();
                }
            },
            onEmitNewCaseData(data) {
                if (this.orgDetail.id == data.case_org.id) {
                    this.openCases.push(data);
                    this.openCasesCount ++;
                }
            },
            showToDealDialog(data) {
                this.opptyData = data;
                this.toDealDialog = true;
            },
            onEmitToDealDialog() {
                this.toDealDialog = false;
            },
            // Dialog Area ----------------------------------------- [End]
            moreDeals() {
                if (this.showDealsMore == true) {
                    this.showDealsMore = false;
                    this.btnText = 'MORE';
                } else {
                    this.showDealsMore = true;
                    this.btnText = 'LESS';
                }
            },
            // chip remove
            // addresseeRemove (item) {
            //     const index = this.addressee.indexOf(item.name)
            //     if (index >= 0) this.addressee.splice(index, 1)
            // },
            // copyRemove (item) {
            //     const index = this.copy.indexOf(item.name)
            //     if (index >= 0) this.copy.splice(index, 1)
            // },
            // email Template Area ----------------------------------------- [Start]
            selectTemplate(v) {
                if (v) {
                    const selectTemplate = _.filter(this.emailTemplateData, { 'idx': v });
                    this.mainEditor = selectTemplate[0].templateContent;
                    this.emailTemplateContactValList = selectTemplate[0].contactTemplateVal;
                    this.emailTemplateDealValList = selectTemplate[0].dealTemplateVal
                } else {
                    this.mainEditor = '';
                    this.emailTemplateContactValList = '';
                    this.emailTemplateDealValList = '';
                }
            },
            onEditorBlur(quill) {
                console.log("editor blur!", quill);
            },
            onEditorFocus(quill) {
                console.log("editor focus!", quill);
            },
            onSelectionChange(range) {
                console.log("selection change!", range);
            },
            onEmailTemplateValChange(val, insertText) {
                if (val && insertText) {
                    this.mainEditor = this.mainEditor.replace(val, insertText);
                }
            },
            // email Template Area ----------------------------------------- [End]
            // About Note
            moreContent(event){
                let n = event.target.closest('div').previousSibling.firstChild;
                if (n.classList.contains('show-more')){
                    n.classList.remove('show-more');
                    event.target.innerText = 'MORE';
                }
                else{
                    n.classList.add('show-more');
                    event.target.innerText = 'LESS';
                }
            },
            getTabName(key){
                if(key == 'note')
                    this.isNoteTab = true;
                else
                    this.isNoteTab = false;
                if(key == 'documents')
                    this.isdocumentTab = true;
                else
                    this.isdocumentTab = false;
                if(key == 'activities')
                    this.isActivityTab = true;
                else
                    this.isActivityTab = false;
                if(key == 'end_customer')
                    this.isEndCustomerTab = true;
                else
                    this.isEndCustomerTab = false;
            },
            onAddNote(){
                this.getNoteData();
                this.addNoteDialog = true; 
            },
            onEditNote(item){
                this.noteData = item;
                this.editNoteDialog = true;
            },
            onEmitEditNoteDialog(val){
                this.editNoteDialog = false;
                if (val) {
                    this.refreshTimeLine();
                    if (this.noteData.content.length > 300) {
                        this.$set(this.noteData, 'isMore_timeLineAll', true);
                        this.$set(this.noteData, 'isMore_timeLineNote', true);
                        this.$set(this.noteData, 'isMore_note', true);
                    } else {
                        this.$set(this.noteData, 'isMore_timeLineAll', false);
                        this.$set(this.noteData, 'isMore_timeLineNote', false);
                        this.$set(this.noteData, 'isMore_note', false);
                    }
                    // this.showSuccessDialog();
                }
            },
            onDeleteNote(id){
                this.showMessageDialog(i18n.t('COMPANY_DETAIL.MESSAGE'));
                this.noteIdOnDelete = id;
                this.delMode = 'delNote';
            },
            onPinNote(item){
                NoteDataService.editNote(this.getPinnData(item))
                .then(() =>{
                    this.refreshTimeLine();
                    if (item.pinned == true) {
                        this.pinning = true;
                    }
                })
                .catch(response => {
                    this.showErrorDialog(response);
                })
            },
            arrangeTimeLine(timelineList){
                let havePinned = timelineList.filter(this.pinnedTrue);
                let noPinned = timelineList.filter(this.pinnedFalse);
                havePinned = havePinned.sort(function(a, b){
                    let aTime = new Date(a.time+"Z");
                    let bTime = new Date(b.time+"Z");
                    return bTime-aTime });
                noPinned = noPinned.sort(function(a, b){
                    let aTime = new Date(a.time+"Z");
                    let bTime = new Date(b.time+"Z");
                    return bTime-aTime });
                return havePinned.concat(noPinned);
            },
            pinnedTrue(obj){
                if ("pinned" in obj && obj.pinned == true)
                    return true;
            },
            pinnedFalse(obj){
                if (!("pinned" in obj))
                    return true;
                else if (obj.pinned == false)
                    return true;
            },
            getPinnData(obj){
                obj.pinned = obj.pinned ? false : true;
                let data = {};
                data.pinned = JSON.parse(JSON.stringify(obj.pinned));
                data.id = JSON.parse(JSON.stringify(obj.id));
                return data;
            },
            deleteNoteFrontEnd(id){
                // delete note in time line
                let item = this.timeLines.find(e => e.id == id);
                let index = this.timeLines.indexOf(item);
                this.timeLines.splice(index, 1);
                // delete note in alert
                let item_alert = this.alertNote.find(e => e.id == id);
                let index_alert = this.alertNote.indexOf(item_alert);
                this.alertNote.splice(index_alert, 1);
            },
            getNoteData(){
                let userJson = window.localStorage.getItem('user');
                let user = JSON.parse(userJson);
                this.noteData = {};
                this.noteData.org = this.orgDetail.id;
                this.noteData.owner = `${user.last_name} ${user.first_name}`;
            },
            getFormatTime(data){
                let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',hour: '2-digit',minute: '2-digit',hour12: false };
                let today  = data;
                if(this.$i18n.locale == "zh_TW")
                {
                   return today.toLocaleDateString("zh-TW", options); 
                }else
                {
                    return today.toLocaleDateString("en-US", options);
                }                 
            },
            getFieldHistoryData(data){
                let userJson = window.localStorage.getItem('user');
                let user = JSON.parse(userJson);
                this.fieldhistoryData = {};
                this.fieldhistoryData.type = "FIELDHISTORY";
                this.fieldhistoryData.timeConvert = this.getFormatTime(new Date());
                this.fieldhistoryData.content = data;                
                this.fieldhistoryData.contact = this.orgDetail.id;                
                this.fieldhistoryData.changed_by = `${user.last_name} ${user.first_name}`;
            },
            onEmitAddNoteDialog(val){
                this.addNoteDialog = false;
                if (val) {
                    if (this.noteData.content.length > 300) {
                        this.$set(this.noteData, 'isMore_timeLineAll', true);
                        this.$set(this.noteData, 'isMore_timeLineNote', true);
                        this.$set(this.noteData, 'isMore_note', true);
                    } else {
                        this.$set(this.noteData, 'isMore_timeLineAll', false);
                        this.$set(this.noteData, 'isMore_timeLineNote', false);
                        this.$set(this.noteData, 'isMore_note', false);
                    }
                    this.timeLines.unshift(this.noteData);
                    this.timeLines = this.arrangeTimeLine(this.timeLines);
                    // this.showSuccessDialog();
                }
            },
            onEmitAddNoteData(data) {
                let index = this.timeLines.findIndex(item => {return item.id == data.id})
                this.timeLines[index].time = data.created_on;
                this.refreshTimeLine();
            },
            hasType(arr, type){
                let answer = arr.some(function(item){
                    return item.type == type;
                }) 
                return answer;
            },
            getGoogleMapSearchURL(address) {
                return 'https://www.google.com/maps/search/' + address;
            },
            getIndustryName(){
                if(this.orgDetail.industry != false && this.orgDetail.industry != null)
                {
                    const indusObj = this.industryList.find(e => e.key == this.orgDetail.industry);
                    return indusObj.name;
                }
            // End Note
            },
            isMore(index, place) {
                if (place == "timeLineAll") {
                    this.timeLines[index].isMore_timeLineAll = this.timeLines[index].isMore_timeLineAll ? false : true;
                } else if (place == "timeLineNote") {
                    this.timeLines[index].isMore_timeLineNote = this.timeLines[index].isMore_timeLineNote ? false : true;
                } else if (place == "NOTE") {
                    this.timeLines[index].isMore_note = this.timeLines[index].isMore_note ? false : true;
                }
            },
            onPinning() {
                this.pinning = false;
            },
            getLittleFormatTime(data){                
                let today  = data;
                if(this.$i18n.locale == "zh_TW")
                {
                   return today.toLocaleDateString("zh-TW"); 
                }else
                {
                    return today.toLocaleDateString("en-US");
                }                 
            },
            setPosition: function(data) {
            if(data==0)	{
                return {
                    top: '0px'				
                }
            }
            else{
                if(this.getfolder == false){ 
                return {
                        top : data*45+'px'
                    }
                }
                else{
                    return {
                        display : 'none'
                    }
                }
            }
            },
            folder(data){			
                if (this.getfolder == false){
                    this.getfolder = true;
                    this.setPosition(data);
                    }
                    else {
                    this.getfolder = false;
                    this.setPosition(data);
                }
            },
            showFormatAmount(data){            
                if(data==='annual_revenue'){
                    if(this.orgDetail.annual_revenue == 0 | this.orgDetail.annual_revenue == "")
                    {
                        this.formatAR = 0
                    }else
                    {
                        this.formatAR = this.getFormatAmount(this.orgDetail.annual_revenue).slice(0,-3)
                    }                
                this.annualRevenueShow = false
                this.aRValidate = this.$refs.editAmount.validate()}
                if(data==='registered_capital'){
                    if(this.orgDetail.registered_capital == 0 | this.orgDetail.registered_capital == "")
                    {
                        this.formatRC = 0
                    }else
                    {
                        this.formatRC = this.getFormatAmount(this.orgDetail.registered_capital).slice(0,-3)
                    }
                this.registeredCapitalShow = false            
                this.rCValidate = this.$refs.editBudget.validate()}
            },
            showEditAmount(data){
                if(!this.isDetailReadonly && data==='annual_revenue')
                {
                    this.annualRevenueShow = true
                    this.$refs.editAmount.focus()
                }   
                if(!this.isDetailReadonly && data==='registered_capital')
                {
                    this.registeredCapitalShow = true
                    this.$refs.editBudget.focus()
                }
            },
            // documnet
            onAddDocument(){
                this.isAddDoucment = true;
            },
            async onDelDocument(){
                this.openDelDocumentDialog = true;
            },
            onEmitDocDialog(){
                this.isAddDoucment = false;
                this.openDelDocumentDialog = false;
            },
            selectDocumentsList(data){
                if(data.length > 0)
                {
                    this.isDelDocument = true;
                }
                else{
                    this.isDelDocument = false;
                }
            },
            // activity
            async getActivityTimeline(){
                await ActivityDataService.getActivityTimeline(this.target_id,"org")
                .then((response)=>{
                    this.activityTimeline = this.arrangeTimeLine(response.data.timelineList);
                    this.activityTimeline.forEach(item => {
                        item.timeConvert = this.getFormatTime(new Date(item.time));
                        item.content = item.content.replace("所有者","負責人");
                        item.content_list = item.content.split(item.activity_subject);
                    })
                    this.due_activity_list = response.data.due_list;
                    this.timeLines = this.arrangeTimeLine(this.originTimeLines.concat(this.activityTimeline));
                    for( let i in this.due_activity_list){
                        let obj={
                            "id": this.due_activity_list[i].id,
                            "type":"DUE_ACTIVITY",
                            "subject": this.due_activity_list[i].subject,
                            "type_name": this.due_activity_list[i].type,
                            "is_due":this.due_activity_list[i].is_due
                        }
                        this.timeLines.unshift(obj);
                    }
                })
                .catch(response => {
                    this.showErrorDialog(response);
                })
            },
            onAddActivity(){
                this.isAddActivity = true;
            },
            async onEmitAddActivity(val){
                this.isAddActivity = false;
                    if(val=="refresh"){
                        await this.getActivityTimeline();
                        await this.showTimlinesCheck();
                    }
            },
            async refreshTimeLine(){
                await this.getOrgTimeLine(this.target_id);
                await this.getActivityTimeline();
                await this.showTimlinesCheck();
            },
            // end_customer
            onAddEndCustomer(){
                this.isAddEndCustomer = true;
            },
            onEmitEndCustomerDialog(){
                this.isAddEndCustomer = false;
            },
            goVcfPage(){
                window.location.href='https://forms.office.com/pages/responsepage.aspx?id=svPwELXCX0SE91hFFZFqghTlgMas8F9Ar7p2ciCDOWNUNk1VVDJENlZFOVZTUkYxMjNWQTUzVkVOVi4u'
            },
            checkTechUser(){
                let user = JSON.parse(window.localStorage.getItem('user'));
                if(user){
                    this.isTechUser = JSON.parse(window.localStorage.getItem('user'))['is_tech_user'];
                    this.is_staff = JSON.parse(window.localStorage.getItem('user'))['is_staff'];
                }
            },
            wiadvanceHideCaseTab(){
                if(this.isWiadvance()){
                    this.wiAdvanceTabs = this.tabs.filter(tab=> tab.key != 'cases');
                    this.tabs = this.wiAdvanceTabs;
                }
            },
            checkWiadvanceShow(){
                if(this.isWiadvance()){
                    this.cFEditable = this.is_staff ? true : false;
                    return this.is_staff;
                }else{
                    return true;
                }
            },
        },
        watch: {
            isDetailReadonly(val){
                this.removeMenu(val);
            }
        }
    }
</script>
<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css';
</style>